class AmazonRefundOrderInfoRpcRequest {
  /** orderNoList */
  orderNoList = [];

  /** shopCodeList */
  shopCodeList = [];
}

class AmazonRefundOrderInfoRpcResponse {
  /** 退款单明细List */
  amazonRefundOrderItemInfoRpcResponseList = [];

  /** 退款失效时间 */
  cancelRefundTime = "";

  /** 币种 */
  currency = "";

  /** 退款生效时间 */
  effectiveRefundTime = "";

  /** 退款单生成方式 1:OMS系统生成 2:CT接口生成 3:平台生成 */
  refundBuildAction = undefined;

  /** 退款单来源 0:erp 1:callcenter */
  refundChannel = undefined;

  /** 退款单号 */
  refundNo = "";

  /** 订单运费退款金额 */
  refundShippingAmount = undefined;

  /** 退款单状态 1待退款 2已退款 3取消退款 */
  refundStatus = undefined;

  /** 退款总金额 */
  refundTotalAmount = undefined;

  /** 退款单类型 1:需要拦截 2:直接退款 */
  refundType = undefined;

  /** 系统订单生成方式 1:平台传输生成 2:系统内创建 */
  soBuildAction = undefined;

  /** 系统订单号 */
  soOrderNo = "";

  /** 店铺编码 */
  spMarketCode = "";

  /** 店铺 */
  spMarketName = "";

  /** 平台单号 */
  spOrderNo = "";

  /** 平台 */
  spPlatform = "";

  /** 平台退款单号 */
  spRefundNo = "";

  /** 平台订单交易价 */
  spTradingPrice = undefined;
}

class ApprovalBeforeRequestDto {
  /** 业务Key，例如盘点单号 */
  businessKey = "";

  /** 页大小 */
  pageNumber = undefined;

  /** 页号 */
  pageSize = undefined;

  /** 流程定义key,盘点：InventoryApproval */
  processKey = "";
}

class ApprovalRequestDto {
  /** 审批状态：待提交：-1，已驳回：0；已通过<流程结束传>：1；审批中<只要流程没结束都是传该状态>：2；已撤回：3 ；已挂起：4；已删除：5；流程终止：-2 */
  approvalStatus = undefined;

  /** 审批意见 */
  approvalSug = "";

  /** 审批流程号 */
  businessKey = "";

  /** 表单数据 */
  formData = undefined;

  /** 本次操作 */
  operateTaskDto = new CurrentTaskDto();

  /** 流程实例id */
  processInstanceId = "";

  /** 流程定义key */
  processKey = "";

  /** 是否需要开启审批流 */
  startApproval = false;

  /** 驳回目标节点 */
  taskDto = new TaskDto();
}

class AsMaterialRejectBillCancelDto {
  /** 退货单号 */
  mrbNo = "";

  /** 消息 */
  msg = "";

  /** 是否成功标识 */
  success = false;
}

class AsMaterialRejectBillInvalidRequestDto {
  /** 退货单号 */
  mrbNo = "";

  /** 平台 */
  platform = "";

  /** 系统单号 */
  soOrderNo = "";
}

class AsMaterialRejectBillItemRequestDto {
  /** 子退货售后单号 */
  childMrbNo = "";

  /** 退货数量 */
  itemReturnQuantity = undefined;

  /** 退货原因 */
  itemReturnReason = "";

  /** 运输状态 */
  mrbTransportation = undefined;

  /** 包裹item编号 */
  pioItemNo = "";

  /** 平台退货原因 */
  platformReturnReason = "";

  /** sku */
  sku = "";

  /** 订单item编号 */
  soItemNo = "";

  /** 子退货售后单号 */
  soOrderNo = "";

  /** 来源单号 */
  spOrderNo = "";
}

class AsMaterialRejectBillItemResponseDto {
  /** 图片链接 */
  imageUrl = "";

  /** 退货原因(En) */
  itemReturnEnReason = "";

  /** 退货数量 */
  itemReturnQuantity = undefined;

  /** 退货原因 */
  itemReturnReason = "";

  /** 关联的退货单号 */
  mrbNo = "";

  /** sku名称 */
  productName = "";

  /** sku名称En */
  productNameEn = "";

  /** SKU */
  sku = "";
}

class AsMaterialRejectBillItemRpcVo {
  /** 派送失败数量 */
  deliveryFailQty = undefined;

  /** 图片地址 */
  image = "";

  /** 包裹单号 */
  opNo = "";

  /** 包裹item编号 */
  pioItemNo = "";

  /** 数量 */
  quantity = undefined;

  /** 已退数量 */
  refundQty = undefined;

  /** sku */
  sku = "";

  /** 商品名称 */
  skuName = "";

  /** 商品英文名称 */
  skuNameEn = "";

  /** 订单item编号 */
  soItemNo = "";
}

class AsMaterialRejectBillItemVo {
  /** 派送失败数量 */
  deliveryFailQty = undefined;

  /** 图片地址 */
  image = "";

  /** 包裹单号 */
  opNo = "";

  /** 包裹item编号 */
  pioItemNo = "";

  /** 数量 */
  quantity = undefined;

  /** 已退数量 */
  refundQty = undefined;

  /** sku */
  sku = "";

  /** 商品名称 */
  skuName = "";

  /** 商品英文名称 */
  skuNameEn = "";

  /** 订单item编号 */
  soItemNo = "";

  /** 系统单号 */
  soOrderNo = "";

  /** 来源单号 */
  spOrderNo = "";

  /** 多渠道订单状态 */
  status = undefined;
}

class AsMaterialRejectBillModel {
  /** 退货金额 */
  amount = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建人姓名 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 是否跨三方仓退货 1是 0不是 */
  crossBorderReturns = false;

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 多订单退货售后单号 */
  directorMrbNo = "";

  /** 面单生成失败原因 */
  failReason = "";

  /** id */
  id = undefined;

  /** 工作流实例ID */
  instanceId = "";

  /** 乐观锁 */
  lockVersion = undefined;

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 逆向物流标志 */
  logisticsFlag = false;

  /** 退货仓库 */
  logisticsReturnWarehouse = "";

  /** 退货仓库编码 */
  logisticsReturnWarehouseCode = "";

  /** 实际退货时间 */
  mrbActualReturnTime = "";

  /** 退货单生成方式 1:系统内生成 */
  mrbBuildAction = undefined;

  /** 取消退货时间 */
  mrbCancelReturnTime = "";

  /** 退款单来源 0:erp 1:callcenter */
  mrbChannel = undefined;

  /** 退货售后单号 */
  mrbNo = "";

  /** 退货状态 1待退货 2已退货 3已取消 */
  mrbStatus = undefined;

  /** 跟踪单号 */
  mrbTrackingNo = "";

  /** 运输状态 */
  mrbTransportation = undefined;

  /** 下载面单路径 */
  path = "";

  /** 面单生成状态 0:未生成 10:生成成功 20:生成失败 */
  pathStatus = undefined;

  /** 退货类型：1退货 2换货 3维修 */
  refundType = undefined;

  /** 系统订单号 */
  soOrderNo = "";

  /** 店铺编码 */
  spMarketCode = "";

  /** 店铺 */
  spMarketName = "";

  /** 平台退货售后单号 */
  spMrbNo = "";

  /** 平台单号 */
  spOrderNo = "";

  /** 平台 */
  spPlatform = "";

  /** 更新人 */
  updateBy = "";

  /** 修改人姓名 */
  updateByName = "";

  /** 更新时间 */
  updateTime = "";
}

class AsMaterialRejectBillMultipleRequestDto {
  /** 是否历史订单 默认false，不是历史订单不需要传该参数，是则传ture */
  historyOrder = false;

  /** 退货单详情 */
  itemRequestDtoList = [];

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 逆向物流生成标志 */
  logisticsFlag = false;

  /** 退货仓库 */
  logisticsReturnWarehouse = "";

  /** 退货仓库编码 */
  logisticsReturnWarehouseCode = "";

  /** 退货单生成方式 1:系统内生成 */
  mrbBuildAction = undefined;

  /** 退款单来源 */
  mrbChannel = undefined;

  /** 跟踪单号 */
  mrbTrackingNo = "";

  /** 退货是否需要校验退款状态 */
  needCheckRefundStatus = false;

  /** 面单路径 */
  path = "";

  /** 面单生成状态 0:未生成 10:生成成功 20:生成失败 */
  pathStatus = undefined;

  /** 退货类型：1退货 2换货 3维修 */
  refundType = undefined;

  /** 逆向物流参数 */
  requestDto = new LogisticsReverseLabelRequestDto();
}

class AsMaterialRejectBillMultipleRpcDto {
  /** 是否历史订单 默认false，不是历史订单不需要传该参数，是则传ture */
  historyOrder = false;

  /** 退货单详情 */
  itemRequestDtoList = [];

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 逆向物流生成标志 */
  logisticsFlag = false;

  /** 退货仓库 */
  logisticsReturnWarehouse = "";

  /** 退货仓库编码 */
  logisticsReturnWarehouseCode = "";

  /** 退货单生成方式 1:系统内生成 */
  mrbBuildAction = undefined;

  /** 退款单来源 */
  mrbChannel = undefined;

  /** 跟踪单号 */
  mrbTrackingNo = "";

  /** 退货是否需要校验退款状态 */
  needCheckRefundStatus = false;

  /** 面单路径 */
  path = "";

  /** 面单生成状态 0:未生成 10:生成成功 20:生成失败 */
  pathStatus = undefined;

  /** 退货类型：1退货 2换货 3维修 */
  refundType = undefined;

  /** 逆向物流参数 */
  requestDto = new LogisticsReverseLabelRequestDto();
}

class AsMaterialRejectBillRequestDto {
  /** 是否跨三方仓退货 1是 0不是 */
  crossBorderReturns = false;

  /** 是否历史订单 默认false，不是历史订单不需要传该参数，是则传ture */
  historyOrder = false;

  /** 退货单详情 */
  itemRequestDtoList = [];

  /** 退货原因 */
  itemReturnReason = "";

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 逆向物流生成标志 */
  logisticsFlag = false;

  /** 退货仓库 */
  logisticsReturnWarehouse = "";

  /** 退货仓库编码 */
  logisticsReturnWarehouseCode = "";

  /** 退货单生成方式 1:系统内生成 */
  mrbBuildAction = undefined;

  /** 退款单来源 */
  mrbChannel = undefined;

  /** 跟踪单号 */
  mrbTrackingNo = "";

  /** 退货是否需要校验退款状态 */
  needCheckRefundStatus = false;

  /** 面单路径 */
  path = "";

  /** 面单生成状态 0:未生成 10:生成成功 20:生成失败 */
  pathStatus = undefined;

  /** 平台退货原因 */
  platformReturnReason = "";

  /** 退货类型：1退货 2换货 3维修 */
  refundType = undefined;

  /** 逆向物流参数 */
  requestDto = new LogisticsReverseLabelRequestDto();

  /** 亚马逊卖家分配给退货商品的标识符 */
  sellerReturnItemId = [];

  /** 系统订单号 */
  soOrderNo = "";

  /** 平台退货售后单号 */
  spMrbNo = "";
}

class AsMaterialRejectBillRequestParamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 创建开始时间 */
  createTimeGe = "";

  /** 创建结束时间 */
  createTimeLe = "";

  /** 是否跨三方仓退货 1是 0不是 */
  crossBorderReturns = false;

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 多订单退货售后单号 */
  directorMrbNo = "";

  /** id */
  id = undefined;

  /** 退货原因 */
  itemReturnReason = "";

  /** 乐观锁 */
  lockVersion = undefined;

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 发货仓库 */
  logisticsDeliveryWarehouse = "";

  /** 发货仓库编码 */
  logisticsDeliveryWarehouseCode = undefined;

  /** 实际退货时间 */
  mrbActualReturnTime = "";

  /** 退货单生成方式 1:系统内生成 */
  mrbBuildAction = undefined;

  /** 取消退货时间 */
  mrbCancelReturnTime = "";

  /** 退货售后单号 */
  mrbNo = "";

  /** 退货售后单号多选，英文逗号分隔 */
  mrbNos = "";

  /** 退货状态 1待退货 2已退货 3已取消 */
  mrbStatus = undefined;

  /** 跟踪单号 */
  mrbTrackingNo = "";

  /** 运输状态 */
  mrbTransportation = undefined;

  /** 平台退货原因 */
  platformReturnReason = "";

  /** sku */
  sku = "";

  /** 商品名称 */
  skuName = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 店铺编码 */
  spMarketCode = "";

  /** 平台单号 */
  spOrderNo = "";

  /** 平台 */
  spPlatform = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class AsMaterialRejectPageRpcDto {
  /** 页数 */
  current = undefined;

  /** directorMrbNo */
  directorMrbNo = "";

  /** 平台退货原因 */
  platformReturnReason = "";

  /** 条数 */
  size = undefined;

  /** 平台单号 */
  spOrderNo = "";

  /** 平台 */
  spPlatform = "";
}

class AsRefundOrderItemRequestDto {
  /** 包裹明细编号list */
  pioItemNoList = [];

  /** 退款金额 */
  refundAmount = undefined;

  /** 退款原因 */
  refundReason = "";

  /** sku */
  sku = "";

  /** 系统订单商品号 */
  soItemNo = "";
}

class AsRefundOrderItemResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 商品图片 */
  image = "";

  /** 图片链接 */
  imageUrl = "";

  /** 乐观锁 */
  lockVersion = undefined;

  /** sku名称 */
  productName = "";

  /** sku名称En */
  productNameEn = "";

  /** 商品数量 */
  quantity = undefined;

  /** 退款金额 */
  refundAmount = undefined;

  /** 退款原因(En) */
  refundEnReason = "";

  /** 退款单号 */
  refundNo = "";

  /** 退款原因 */
  refundReason = "";

  /** 退款原因Code */
  refundReasonCode = "";

  /** SKU */
  sku = "";

  /** 商品名称 */
  skuName = "";

  /** 系统订单商品号 */
  soItemNo = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class AsRefundOrderItemResponseRpc {
  /** 图片链接 */
  image = "";

  /** 商品交易价格 */
  itemTradingPrice = undefined;

  /** 可退金额 */
  leftRefundAmount = undefined;

  /** 商品数量 */
  quantity = undefined;

  /** 包裹信息 */
  responseRpcDtos = [];

  /** SKU */
  sku = "";

  /** sku名称 */
  skuName = "";

  /** sku名称En */
  skuNameEn = "";

  /** 系统订单商品号 */
  soItemNo = "";

  /** 已退金额 */
  soRefundAmount = undefined;

  /** 平台订单商品编码(平台订单行) */
  spItemNo = "";

  /** 商品税费金额 */
  taxesAmount = undefined;
}

class AsRefundOrderItemRpcDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 商品图片 */
  image = "";

  /** 图片链接 */
  imageUrl = "";

  /** 乐观锁 */
  lockVersion = undefined;

  /** sku名称 */
  productName = "";

  /** sku名称En */
  productNameEn = "";

  /** 商品数量 */
  quantity = undefined;

  /** 退款金额 */
  refundAmount = undefined;

  /** 退款原因(En) */
  refundEnReason = "";

  /** 退款单号 */
  refundNo = "";

  /** 退款原因 */
  refundReason = "";

  /** 退款原因Code */
  refundReasonCode = "";

  /** SKU */
  sku = "";

  /** 商品名称 */
  skuName = "";

  /** 系统订单商品号 */
  soItemNo = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class AsRefundOrderRequestDto {
  /** 退款单明细 */
  itemRequestDtoList = [];

  /** 退款单生成方式 1:OMS系统生成 2:CT接口生成 */
  refundBuildAction = undefined;

  /** 退款单来源 0:erp 1:callcenter */
  refundChannel = undefined;

  /** 退款单号 */
  refundNo = "";

  /** 订单运费退款 */
  refundSpShipping = undefined;

  /** 退款单类型 1:需要拦截 2:直接退款 */
  refundType = undefined;

  /** 店铺编码 */
  shopCode = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 订单来源 */
  spPlatform = "";

  /** 退款总金额 */
  totalRefundAmount = undefined;
}

class AsRefundOrderRequestParamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建开始时间 */
  createTimeGe = "";

  /** 创建结束时间 */
  createTimeLe = "";

  /** 退款方式 1:产品退款 2:仅运费退款 */
  refundMethod = undefined;

  /** 退款单号 */
  refundNo = "";

  /** 退款单号多选，英文逗号分隔 */
  refundNos = "";

  /** 退款原因 */
  refundReason = "";

  /** 退款单状态 1待退款 2已退款 3取消退款 */
  refundStatus = undefined;

  /** sku */
  sku = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 店铺编码 */
  spMarketCode = "";

  /** 平台订单号 */
  spOrderNo = "";

  /** 平台 */
  spPlatform = "";
}

class AssigneeDto {
  /** 操作人内部编号 */
  userCode = "";

  /** 操作人名称 */
  userName = "";
}

class AssociateSkuParamDto {
  /** 关联订单号 */
  associateSku = [];

  /** 系统订单号 */
  soOrderNo = "";
}

class AssociateSkuParamRpcDto {
  /** 关联订单号 */
  associateSku = [];

  /** 系统订单号 */
  soOrderNo = "";
}

class BatchUnLockReqDto {
  /** 包裹号数组 */
  opNos = [];

  /** 订单号 */
  soOrderNo = "";
}

class BatchUnLockRespDto {
  /** 错误信息 */
  msg = "";

  /** 包裹单号 */
  opNo = "";
}

class BusinessOrderPackageDetachableVo {
  /** 已锁定的包裹单号 */
  lockOpNoList = [];

  /** 原包裹单号 */
  opNoList = [];

  /** 包裹详情 */
  orderPackageDetailVos = [];

  /** 系统订单号 */
  soOrderNo = "";
}

class BusinessOrderPackageDetailVo {
  /** 是否可以进行包裹拆分 */
  canDetachable = false;

  /** 锁定仓库 */
  lockWarehouse = "";

  /** 锁定仓库编码 */
  lockWarehouseCode = "";

  /** 包裹单号（只有不可拆分包裹有） */
  opNo = "";

  /** sku详情 */
  orderPackageItemDetailVos = [];
}

class BusinessOrderPackageItemDetailVo {
  /** 包裹单item类型 */
  pioType = undefined;

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 系统订单商品号 */
  soItemNo = "";

  /** 平台订单商品号 */
  spItemNo = "";

  /** 交易号 */
  transactionId = "";
}

class CheckFulfillmentOrderDto {
  /** opNo */
  opNo = "";

  /** opNoList */
  opNoList = [];

  /** soOrderNo */
  soOrderNo = "";
}

class CheckFulfillmentOrderRpcDto {
  /** 包裹单号 */
  opNo = "";

  /** 多个包裹单号 */
  opNoList = [];

  /** 订单编号 */
  soOrderNo = "";
}

class CrateMskuMapAndFnskuRpcDto {
  /** fnskuToMapRpcDtos */
  fnskuToMapRpcDtos = [];

  /** mskuMapSaveRequestDto */
  mskuMapSaveRequestDto = new MskuMapSaveRequestRpcDto();
}

class CreatePackageToItemIdRequestDto {
  /** itemId */
  itemId = [];

  /** soOrderNo */
  soOrderNo = "";
}

class CurrentTaskDto {
  /** 节点当前处理人 */
  currentAssignee = new AssigneeDto();

  /** 节点编码 */
  nodeKey = "";

  /** 节点名称 */
  nodeName = "";

  /** 节点操作类型 驳回指定节点:backToStart；驳回:reject；通过:pass,；反对：oppose；弃权：abandon；终止：cadence */
  operate = "";

  /** 任务id */
  taskId = "";
}

class DeliveryInformationRequestDto {
  /** 门牌号 */
  houseNumber = "";

  /** 发件人EORI */
  opEori = "";

  /** 收件人地址1 */
  opShippingAddress1 = "";

  /** 收件人地址2 */
  opShippingAddress2 = "";

  /** 收件人城市 */
  opShippingCity = "";

  /** 收件人所在国家 */
  opShippingCountry = "";

  /** 收件人所在国家编码 */
  opShippingCountryCode = "";

  /** 收件人邮箱 */
  opShippingEmail = "";

  /** 收件人名字 */
  opShippingName = "";

  /** 收件人电话 */
  opShippingPhone = "";

  /** 收件人邮编 */
  opShippingPostCode = "";

  /** 收件人州或省 */
  opShippingStateOrProvince = "";

  /** 收件人州或省编码 */
  opShippingStateOrProvinceCode = "";

  /** 发件人VAT */
  opVat = "";
}

class DeliveryItemRequestDto {
  /** 货币 */
  currency = "";

  /** 售价 */
  price = undefined;

  /** 数量 */
  qty = undefined;

  /** 实际sku */
  sku = "";

  /** 标题 */
  title = "";
}

class DetachablePackageItemParamDto {
  /** 是否进行包裹拆分 */
  canDetachable = false;

  /** 包裹单号（只有不可拆分包裹有） */
  opNo = "";

  /** 包裹单信息 */
  packageItemParamDto = [];
}

class DetachablePackageItemParamRpcDto {
  /** 是否进行包裹拆分 */
  canDetachable = false;

  /** 包裹单号（只有不可拆分包裹有） */
  opNo = "";

  /** 包裹单信息 */
  packageItemParamDto = [];
}

class DetachablePackageParamDto {
  /** 包裹 */
  itemParamDtos = [];

  /** 已锁定的包裹单号（ToB） */
  lockOpNoList = [];

  /** 原包裹单 */
  opNos = [];

  /** 系统订单号 */
  soOrderNo = "";
}

class DetachablePackageRpcDto {
  /** 包裹 */
  itemParamDtos = [];

  /** 已锁定的包裹单号（ToB） */
  lockOpNoList = [];

  /** 原包裹单 */
  opNos = [];

  /** 系统订单号 */
  soOrderNo = "";
}

class Element {
  /** key */
  key = "";

  /** value */
  value = undefined;
}

class ExchangeGoodsItemDto {
  /** 数量 */
  qty = undefined;

  /** 换货列表 */
  sku = "";
}

class FnskuMapItemRequestDto {
  /** 实体标识 0代表新增 1编辑 2代表删除 */
  entityFlag = undefined;

  /** fnsku */
  fnsku = "";

  /** id */
  id = undefined;

  /** msku */
  msku = "";

  /** platform */
  platform = "";

  /** platformShopCode */
  platformShopCode = "";

  /** platformShopName */
  platformShopName = "";

  /** fnsku */
  productName = "";
}

class FnskuMapItemResponseDto {
  /** 是否可以编辑标识，1代表可以编辑/删除 */
  canEditFlag = undefined;

  /** fnsku */
  fnsku = "";

  /** id */
  id = undefined;

  /** msku */
  msku = "";

  /** platform */
  platform = "";

  /** platformShopCode */
  platformShopCode = "";

  /** platformShopName */
  platformShopName = "";

  /** fnsku */
  productName = "";
}

class FnskuMapsItemRequestDto {
  /** fnsku */
  fnsku = "";

  /** msku */
  msku = "";

  /** 平台 */
  platform = "";

  /** fnsku */
  productName = "";

  /** 店铺编码code */
  shopCode = "";

  /** 店铺 */
  shopName = "";
}

class FnskuToMapRpcDto {
  /** fnsku */
  fnsku = "";

  /** msku */
  msku = "";

  /** 产品名称 */
  platform = "";

  /** 产品名称 */
  productName = "";

  /** 店铺编码code */
  shopCode = "";

  /** 店铺 */
  shopName = "";
}

class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class InPlanDetailCreateRequestParamsDto {
  /** 计划入库数 */
  planQty = undefined;

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** sku */
  skuNo = "";

  /** 单价 */
  unitPrice = undefined;
}

class LockStockItemRequestDto {
  /** 锁定数量 */
  lockQty = undefined;

  /** 包裹item编号 */
  pioItemNo = "";

  /** sku */
  sku = "";
}

class LockStockItemResponseDto {
  /** 锁定数量 */
  lockQty = undefined;

  /** 包裹item编号 */
  pioItemNo = "";

  /** 数量 */
  quantity = undefined;

  /** sku */
  sku = "";

  /** 系统订单商品号 */
  soItemNo = "";

  /** 平台订单商品号 */
  spItemNo = "";
}

class LockStockRequestDto {
  /** 锁定明细 */
  lockStockItemList = [];

  /** 锁定仓库 */
  lockWarehouse = "";

  /** 锁定仓库编码 */
  lockWarehouseCode = "";

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 包裹单号 */
  opNo = "";
}

class LockStockResponseDto {
  /** 锁定明细 */
  lockStockItemList = [];

  /** 锁定仓库 */
  lockWarehouse = "";

  /** 锁定仓库编码 */
  lockWarehouseCode = "";

  /** 包裹单号 */
  opNo = "";
}

class LockStockRootRequestDto {
  /** 是否锁定, true:锁定 false:释放 */
  lockFlag = false;

  /** 锁定列表 */
  lockStockList = [];
}

class LockStockRootResponseDto {
  /** 锁定列表 */
  lockStockList = [];
}

class LogisticsReverseLabelRequestDto {
  /** sku明细 */
  detailRequestDtos = [];

  /** 发件人地址1 */
  fromAddress1 = "";

  /** 发件人地址2 */
  fromAddress2 = "";

  /** 发件人城市 */
  fromCity = "";

  /** 发件人国家 */
  fromCounty = "";

  /** 发件人国家简称 */
  fromCountyCode = "";

  /** 发件人姓名 */
  fromName = "";

  /** 发件人电话号码 */
  fromPhone = "";

  /** 发件人邮编 */
  fromPostCode = "";

  /** 发件人州 */
  fromProvince = "";

  /** 发件人州简称 */
  fromProvinceCode = "";

  /** 标签备注 */
  labelRemark = "";

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 包裹明细 */
  omsPackageInfoDtos = [];

  /** 销售订单号 */
  orderNo = "";

  /** 平台编号 */
  platformCode = "";

  /** 退货单号(平台订单号) */
  returnOrderId = "";

  /** 店铺编号 */
  shopCode = "";

  /** 订单编号 */
  soOrderNo = "";

  /** 收件人地址1 */
  toAddress1 = "";

  /** 收件人地址2 */
  toAddress2 = "";

  /** 收件人城市 */
  toCity = "";

  /** 收件人国家 */
  toCounty = "";

  /** 收件人国家简称 */
  toCountyCode = "";

  /** 收件人姓名 */
  toName = "";

  /** 收件人电话号码 */
  toPhone = "";

  /** 收件人邮编 */
  toPostCode = "";

  /** 收件人州 */
  toProvince = "";

  /** 收件人州简称 */
  toProvinceCode = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 退货仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class ManualTrackingPayPalDto {
  /** 包裹单号 */
  opNo = "";

  /** PayPal账号 */
  paypalAccount = "";
}

class MskuMapItemRequestRpcDto {
  /** msku表Id */
  mskuMapId = undefined;

  /** 平台 */
  platform = "";

  /** 数量 */
  quantity = undefined;

  /** 备注 */
  remark = "";

  /** 店铺 */
  shopName = "";

  /** 站点 */
  site = "";

  /** sku */
  sku = "";
}

class MskuMapItemResponseDto {
  /** id */
  id = undefined;

  /** msku表Id */
  mskuMapId = undefined;

  /** 平台 */
  platform = "";

  /** 数量 */
  quantity = undefined;

  /** 备注 */
  remark = "";

  /** 店铺 */
  shopName = "";

  /** 站点 */
  site = "";

  /** sku */
  sku = "";

  /** 产品标签CN */
  skuNameCn = "";

  /** 产品标签EN */
  skuNameEn = "";
}

class MskuMapItemResponseDto0 {
  /** msku表Id */
  mskuMapId = undefined;

  /** 平台 */
  platform = "";

  /** 数量 */
  quantity = undefined;

  /** 备注 */
  remark = "";

  /** 店铺 */
  shopName = "";

  /** 站点 */
  site = "";

  /** sku */
  sku = "";
}

class MskuMapParamsResponseDto {
  /** 创建时间 */
  createTime = "";

  /** 有效期结束 */
  disabledTime = "";

  /** 有效期开始 */
  effectiveTime = "";

  /** fnsku详情 */
  fnskuMapItemResponseDtos = [];

  /** id */
  id = undefined;

  /** 1全平台 2店铺映射 */
  mapperType = undefined;

  /** msku */
  msku = "";

  /** msku详情 */
  mskuMapItemResponseDtos = [];

  /** 0 正常 1 差价 2 保险费 */
  mskuType = undefined;

  /** 平台 */
  platform = "";

  /** 是否是翻新SKU：0不是 1是 */
  renovateSku = undefined;

  /** 店铺编码Code */
  shopCode = "";

  /** 店铺 */
  shopName = "";

  /** 站点 */
  site = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 更新时间 */
  updateTime = "";

  /** 是否虚拟sku 0不是 1是 */
  virtualSku = undefined;
}

class MskuMapParamsRpcDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 有效期结束 */
  disabledTime = "";

  /** 有效期开始 */
  effectiveTime = "";

  /** fnskuMapsItemRequestDtos */
  fnskuMapsItemRequestDtos = [];

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 1全平台 2店铺映射 */
  mapperType = undefined;

  /** msku */
  msku = "";

  /** mskuMapItemResponseDtos */
  mskuMapItemRpcDtoList = [];

  /** 平台 */
  platform = "";

  /** 备注 */
  remark = "";

  /** 是否是翻新SKU：0不是 1是 */
  renovateSku = undefined;

  /** 店铺编码Code */
  shopCode = "";

  /** 店铺 */
  shopName = "";

  /** 站点 */
  site = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 是否虚拟sku 0不是 1是 */
  virtualSku = undefined;
}

class MskuMapSaveRequestDto {
  /** 映射类型 1全平台 2店铺映射 */
  mapperType = undefined;

  /** mskuMapsRequestDtos */
  mskuMapsRequestDtos = [];

  /** 平台 */
  platform = "";

  /** shopKeys */
  shopKeys = [];
}

class MskuMapSaveRequestRpcDto {
  /** 映射类型 1全平台 2店铺映射 */
  mapperType = undefined;

  /** mskuMapsRequestDtos */
  mskuMapsRequestDtos = [];

  /** 平台 */
  platform = "";

  /** shopKeys */
  shopKeys = [];
}

class MskuMapsItemResponseDto {
  /** id */
  id = undefined;

  /** msku表Id */
  mskuMapId = undefined;

  /** 平台 */
  platform = "";

  /** 数量 */
  quantity = undefined;

  /** 备注 */
  remark = "";

  /** 店铺 */
  shopName = "";

  /** 站点 */
  site = "";

  /** sku */
  sku = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;
}

class MskuMapsParamsResponseDto {
  /** 有效期结束 */
  disabledTime = "";

  /** 有效期开始 */
  effectiveTime = "";

  /** id */
  id = undefined;

  /** 1全平台 2店铺映射 */
  mapperType = undefined;

  /** msku */
  msku = "";

  /** mskuMapItemResponseDtos */
  mskuMapItemResponseDtos = [];

  /** 平台 */
  platform = "";

  /** 备注 */
  remark = "";

  /** 店铺 */
  shopName = "";

  /** 站点 */
  site = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 是否虚拟sku 0不是 1是 */
  virtualSku = undefined;
}

class MskuMapsRequestDto {
  /** 有效期结束 */
  disabledTime = "";

  /** 有效期开始 */
  effectiveTime = "";

  /** fnsku列表 */
  fnskuMapItemRequestDtoList = [];

  /** id */
  id = undefined;

  /** 映射类型 1全平台 2店铺映射 */
  mapperType = undefined;

  /** msku */
  msku = "";

  /** mskuMapItemRequestDtos */
  mskuMapItemRequestDtos = [];

  /** 0 正常 1 差价 2 保险费 */
  mskuType = undefined;

  /** 店铺编码Code */
  oldMsku = "";

  /** 店铺编码Code */
  oldShopCode = "";

  /** 平台 */
  platform = "";

  /** 是否是翻新SKU：0不是 1是 */
  renovateSku = undefined;

  /** 店铺编码Code */
  shopCode = "";

  /** shopKey */
  shopKey = "";

  /** 店铺 */
  shopName = "";

  /** 站点 */
  site = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 是否虚拟sku 0不是 1是 */
  virtualSku = undefined;
}

class MskuMapsRequestRpcDto {
  /** 有效期结束 */
  disabledTime = "";

  /** 有效期开始 */
  effectiveTime = "";

  /** id */
  id = undefined;

  /** 映射类型 1全平台 2店铺映射 */
  mapperType = undefined;

  /** msku */
  msku = "";

  /** mskuMapItemRequestDtos */
  mskuMapItemRequestDtos = [];

  /** 店铺编码Code */
  oldMsku = "";

  /** 店铺编码Code */
  oldShopCode = "";

  /** 平台 */
  platform = "";

  /** 店铺编码Code */
  shopCode = "";

  /** shopKey */
  shopKey = "";

  /** 店铺 */
  shopName = "";

  /** 站点 */
  site = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 是否虚拟sku 0不是 1是 */
  virtualSku = undefined;
}

class MskuRequestRpcDto {
  /** fnsku */
  fnsku = "";

  /** msku */
  msku = "";

  /** 平台 */
  platform = "";

  /** 店铺编码 */
  shopCode = "";

  /** sku */
  sku = "";
}

class OmsFlowPackageChangeDetailRequestDto {
  /** 出库计划单号 */
  opno = "";

  /** sku明细 */
  skuList = [];

  /** 新包裹单号 */
  sourceNo = "";

  /** 来源类型 */
  sourceType = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class OmsFlowPackageChangeDetailSkuRequestDto {
  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";
}

class OmsFlowPackageChangeRequestDto {
  /** 齐货包裹 */
  adequatePackages = [];

  /** 缺货包裹 */
  lackPackage = new OmsFlowPackageChangeDetailRequestDto();

  /** 出库计划单号 */
  opno = "";

  /** 订单号 */
  orderNo = "";

  /** 包裹单号 */
  sourceNo = "";
}

class OmsPackageInfoDetailDto {
  /** 数量 */
  qty = undefined;

  /** 实收数量 */
  realQty = undefined;

  /** sku编号 */
  skuNo = "";
}

class OmsPackageInfoDto {
  /** 创建时间 */
  createTime = "";

  /** 包裹明细 */
  omsPackageInfoDetailDtos = [];

  /** 包裹单号 */
  packageNo = "";

  /** 平台编号 */
  platformCode = "";

  /** 退货单号 */
  returnOrderId = "";
}

class OptionalShippingMethodDto {
  /** 是否自动出库，平台订单默认开启，TOB类型需要关闭，关闭走库存锁定逻辑 */
  autoDirectShipFlag = false;

  /** 多渠道订单是否不使用亚马逊物流运送 1:是 0:否 默认不使用 默认 0 */
  blockAmazonLogisticFlag = undefined;

  /** 多渠道订单是否使用无标记箱子发货 1:是 0:否 默认使用无标记 默认1 */
  onlyBlankBoxesFlag = undefined;

  /** 是否申请多渠道订单 1:是 0:否 */
  optionalIsMcf = undefined;

  /** 自选物流渠道 */
  optionalLogisticsChannel = "";

  /** 自选物流渠道编码 */
  optionalLogisticsChannelCode = "";

  /** 自选物流商 */
  optionalLogisticsCompany = "";

  /** 自选物流商编码 */
  optionalLogisticsCompanyCode = "";

  /** 自选发货仓库 */
  optionalLogisticsDeliveryWarehouse = "";

  /** 自选发货仓库编码 */
  optionalLogisticsDeliveryWarehouseCode = "";

  /** 自选店铺编号 */
  optionalShopKey = "";

  /** 自选店铺名称 */
  optionalShopName = "";
}

class OptionalShippingRequestDto {
  /** 是否自动出库，平台订单默认开启，TOB类型需要关闭，关闭走库存锁定逻辑 */
  autoDirectShipFlag = false;

  /** 多渠道订单是否不使用亚马逊物流运送 1:是 0:否 默认不使用 默认 0 */
  blockAmazonLogisticFlag = undefined;

  /** 多渠道订单是否使用无标记箱子发货 1:是 0:否 默认使用无标记 默认1 */
  onlyBlankBoxesFlag = undefined;

  /** 是否申请多渠道订单 1:是 0:否 */
  optionalIsMcf = undefined;

  /** 自选物流渠道 */
  optionalLogisticsChannel = "";

  /** 自选物流渠道编码 */
  optionalLogisticsChannelCode = "";

  /** 自选物流商 */
  optionalLogisticsCompany = "";

  /** 自选物流商编码 */
  optionalLogisticsCompanyCode = "";

  /** 自选发货仓库 */
  optionalLogisticsDeliveryWarehouse = "";

  /** 自选发货仓库编码 */
  optionalLogisticsDeliveryWarehouseCode = "";

  /** 自选店铺编号 */
  optionalShopKey = "";

  /** 自选店铺名称 */
  optionalShopName = "";

  /** 发货备注 */
  shippingNote = "";
}

class OrderAsRefundDto {
  /** 订单退款dto */
  orderRefundDto = new OrderRefundDto();

  /** 店铺编码 */
  shopCode = "";

  /** sp订单id */
  spOrderId = "";
}

class OrderAvgPriceResponseDto {
  /** 平均价格 */
  avgPrice = undefined;

  /** msku */
  msku = "";

  /** shopKey */
  shopKey = "";

  /** 币种 */
  spCurrency = "";

  /** 月份:current、last */
  type = "";
}

class OrderDetailRequestDto {
  /** 店铺shopNo列表 */
  marketCodeList = [];

  /** 平台订单单号列表 */
  orderList = [];

  /** so订单列表,和平台单号列表两者必须要有一个,如果存在so订单列表,则以so订单列表为准 */
  soOrderNoList = [];
}

class OrderDetailResponseDto {
  /** 详情 */
  orderInfoSkuResponseDtoList = [];

  /** 原订单类型 1正常 2补发 3重发 4测评 5改发 6换货 7维修 */
  originalSoType = undefined;

  /** 原订单贸易主体编码 */
  originalTradeCompanyCode = "";

  /** 原订单贸易主体名称 */
  originalTradeCompanyName = "";

  /** 系统订单售后状态 1正常 2退款 3部分退款 4退货 5部分退货 */
  soAfterSaleStatus = undefined;

  /** OMS订单号 */
  soOrderNo = "";

  /** 系统订单付款状态 0未付款 1已付款 2部分退款 3已退款 */
  soPayStatus = undefined;

  /** 系统订单退款金额 */
  soRefundAmount = undefined;

  /** 系统订单状态:0未付款 1待审核  2待发货 3缺货 4物流问题 5发货问题 6部分发货 7已完成 8已取消 9风险订单 10已拦截  11异常确认 12派送失败 13已签收 */
  soStatus = undefined;

  /** 贸易主体编码 */
  soTradeCompanyCode = "";

  /** 贸易主体名称 */
  soTradeCompanyName = "";

  /** 系统订单类型 1正常 2补发 3重发 4测评 5改发 6换货 7维修 */
  soType = undefined;

  /** OMS原订单号,补发/代发则是原有单号 */
  sourceOrderId = "";

  /** 平台订单佣金 */
  spCommission = undefined;

  /** 平台订单币种 */
  spCurrency = "";

  /** 平台订单优惠额 */
  spDiscount = undefined;

  /** 平台订单店铺 */
  spMarketCode = "";

  /** 平台订单店铺名称 */
  spMarketName = "";

  /** 平台订单id（平台生成） */
  spOrderId = "";

  /** 平台订单号（客服填写） */
  spOrderNo = "";

  /** 平台订单下单时间 */
  spOrderTime = "";

  /** 平台订单实收款 */
  spPayAmount = undefined;

  /** 平台订单支付时间 */
  spPaymentDate = "";

  /** 平台订单来源平台 */
  spPlatform = "";

  /** 平台订单退款金额 */
  spRefundAmount = undefined;

  /** 平台订单备注 */
  spRemark = "";

  /** 平台订单销售价 */
  spSalesPrice = undefined;

  /** 平台订单运费 */
  spShipping = undefined;

  /** 平台订单发货状态 1未发货 2部分发货 3已发货 */
  spShippingStatus = undefined;

  /** 平台订单状态 */
  spStatus = "";

  /** 平台订单税费(税额) */
  spTaxes = undefined;

  /** 平台订单交易价 */
  spTradingPrice = undefined;
}

class OrderInfoRequestDto {
  /** 店铺code列表 */
  shopNoList = [];

  /** 平台订单列表 */
  spOrderIds = [];
}

class OrderInfoResponseDto {
  /** 系统订单号 */
  soOrderNo = "";

  /** 系统订单类型 1正常 2补发 3重发 4测评 5改发 6换货 7维修 */
  soType = undefined;

  /** 平台订单店铺 */
  spMarketCode = "";

  /** 平台订单店铺名称 */
  spMarketName = "";

  /** 平台订单id（平台生成） */
  spOrderId = "";

  /** 平台订单号（客服填写） */
  spOrderNo = "";
}

class OrderInfoSkuResponseDto {
  /** 财务商品支付单价 */
  financeItemPayPrice = undefined;

  /** 财务商品支付总价格 */
  financeItemTotalPayPrice = undefined;

  /** 出货金额 */
  itemAmount = undefined;

  /** 商品销售价格 */
  itemPrice = undefined;

  /** 商品价格的税费 */
  itemTax = undefined;

  /** 商品总价格 */
  itemTotalPrice = undefined;

  /** 商品交易价格 */
  itemTradingPrice = undefined;

  /** 包裹号 */
  opNo = "";

  /** 包裹item编号 */
  pioItemNo = "";

  /** 包裹单item类型：1正常 2换货 */
  pioType = undefined;

  /** 销售sku(mSku) */
  platformSku = "";

  /** 数量 */
  quantity = undefined;

  /** 发货数量 */
  quantityShipment = undefined;

  /** 已退数量 */
  refundQty = undefined;

  /** sku */
  sku = "";

  /** 系统订单商品号 */
  soItemNo = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 平台订单商品号 */
  spItemNo = "";

  /** 平台商品发货状态 1未发货 2已发货 */
  spItemShipping = undefined;
}

class OrderItem {
  /** asc */
  asc = false;

  /** column */
  column = "";
}

class OrderItemDetailResponseDto {
  /** 图片 */
  image = "";

  /** 商品支付价格 */
  itemPayPrice = undefined;

  /** 售价 */
  itemPrice = undefined;

  /** 商品交易价格 */
  itemTradingPrice = undefined;

  /** 商品英文名称 */
  platformSkuName = "";

  /** 数量 */
  qty = undefined;

  /** SKU */
  sku = "";

  /** 商品名称 */
  skuName = "";

  /** 币种 */
  spCurrency = "";
}

class OrderItemDetailResponseDtoForFreshDeskData {
  /** 图片 */
  image = "";

  /** 售价 */
  itemPrice = undefined;

  /** 商品交易价格 */
  itemTradingPrice = undefined;

  /** platform */
  platform = "";

  /** 商品英文名称 */
  platformSkuName = "";

  /** 数量 */
  qty = undefined;

  /** SKU */
  sku = "";

  /** 商品名称 */
  skuName = "";

  /** 币种 */
  spCurrency = "";

  /** spOrderNo */
  spOrderNo = "";
}

class OrderLastMskuPriceResponseDto {
  /** 商品销售价格 */
  itemPrice = undefined;

  /** 商品交易价格 */
  itemTradingPrice = undefined;

  /** msku */
  msku = "";

  /** shopKey */
  shopKey = "";

  /** 币种 */
  spCurrency = "";
}

class OrderPackageDetachableRpcDto {
  /** 包裹详情 */
  packageDetailResponseDtos = [];

  /** 系统订单号 */
  soOrderNo = "";
}

class OrderPackageDetachableVo {
  /** 包裹详情 */
  orderPackageDetailVos = [];

  /** 系统订单号 */
  soOrderNo = "";
}

class OrderPackageDetailResponseDto {
  /** 是否可以直接提交订单 */
  checkSubmit = false;

  /** 物流渠道 */
  logisticsChannel = "";

  /** 发货时间 */
  logisticsDeliveryTime = "";

  /** 发货仓库 */
  logisticsDeliveryWarehouse = "";

  /** 发货仓库编码 */
  logisticsDeliveryWarehouseCode = "";

  /** 推送到PayPal状态 1未推送 2 推送成功 3 推送失败 */
  logisticsPaypalTracking = undefined;

  /** 物流单号 */
  logisticsTrackingNo = "";

  /** 包裹单 */
  opNo = "";

  /** 包裹状态 */
  opStatus = undefined;

  /** 包裹重量(g) */
  opWeight = "";

  /** sku详情 */
  orderPackageItemDetailVos = [];

  /** 退件原因详情 */
  returnExplain = "";

  /** 退件原因 */
  returnReason = "";

  /** 退件时间 */
  returnTime = "";

  /** 系统订单号 */
  soOrderNo = "";
}

class OrderPackageDetailVo {
  /** 是否可以直接提交订单 */
  checkSubmit = false;

  /** 物流渠道 */
  logisticsChannel = "";

  /** 发货时间 */
  logisticsDeliveryTime = "";

  /** 发货仓库 */
  logisticsDeliveryWarehouse = "";

  /** 推送到PayPal状态 1未推送 2 推送成功 3 推送失败 */
  logisticsPaypalTracking = undefined;

  /** 物流单号 */
  logisticsTrackingNo = "";

  /** 包裹单 */
  opNo = "";

  /** 包裹状态 */
  opStatus = undefined;

  /** 包裹重量(g) */
  opWeight = "";

  /** sku详情 */
  orderPackageItemDetailVos = [];

  /** 是否翻新SKU 0不是 1是 */
  renovateSku = undefined;

  /** 退件原因详情 */
  returnExplain = "";

  /** 退件原因 */
  returnReason = "";

  /** 退件时间 */
  returnTime = "";

  /** 系统订单号 */
  soOrderNo = "";
}

class OrderPackageItemDetailResponseDto {
  /** 包裹item编号 */
  pioItemNo = "";

  /** 包裹单item类型 */
  pioType = undefined;

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 系统订单商品号 */
  soItemNo = "";

  /** 平台订单商品号 */
  spItemNo = "";
}

class OrderPackageItemDetailVo {
  /** 包裹item编号 */
  pioItemNo = "";

  /** 包裹单item类型 */
  pioType = undefined;

  /** 数量 */
  qty = undefined;

  /** 翻新SKU */
  renovateSku = undefined;

  /** sku */
  sku = "";

  /** 系统订单商品号 */
  soItemNo = "";

  /** 平台订单商品号 */
  spItemNo = "";

  /** 交易号 */
  transactionId = "";
}

class OrderParamRequestDto {
  /** 是否生成包裹单 */
  autoCreatePg = false;

  /** 是否查找贸易主体 */
  autoMatchTradeBody = false;

  /** 是否推送wms */
  autoSendWms = false;

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 发货信息 */
  deliveryInformationRequestDto = new DeliveryInformationRequestDto();

  /** 发货明细 */
  deliveryItemRequestDtoList = [];

  /** 是否加急订单 */
  earlyOrder = false;

  /** 是否eaby的EIS订单 */
  eisOrder = false;

  /** 是否需要物流地址校验 */
  needCheckDeliveryAddress = false;

  /** 是否需要扣减库存 */
  needReduceStocks = false;

  /** 是否需要sku映射 */
  needSkuMap = false;

  /** 货运方式 */
  optionalShippingRequestDto = new OptionalShippingRequestDto();

  /** 推送方式，默认是RPC推送 */
  orderParamMethod = undefined;

  /** 订单数据 */
  platformOrderDto = new PlatformOrderDto();

  /** 订单商品数据 */
  platformOrderItemDtoList = [];
}

class OrderRefundDto {
  /** 退款失效时间 */
  cancelRefundTime = "";

  /** 币种 */
  currency = "";

  /** 退款生效时间 */
  effectiveRefundTime = "";

  /** 退款商品详情 */
  orderRefundItemDtoList = [];

  /** 退款单生成方式 1:OMS系统生成 2:CT接口生成 */
  refundBuildAction = undefined;

  /** 退款单号 */
  refundNo = "";

  /** 退款单状态 1待退款 2已退款 3取消退款 */
  refundStatus = undefined;

  /** 退款总金额 */
  refundTotalAmount = undefined;

  /** 退款单类型 1:需要拦截 2:直接退款 */
  refundType = undefined;
}

class OrderRefundItemDto {
  /** 币种 */
  currency = "";

  /** 退款金额 */
  refundAmount = undefined;

  /** 退款单号 */
  refundNo = "";

  /** 退款原因 */
  refundReason = "";

  /** 退款单状态 1待退款 2已退款 3取消退款 */
  refundStatus = undefined;

  /** sku */
  sku = "";

  /** 系统订单商品号 */
  soItemNo = "";
}

class OrderSkuItem {
  /** 已退数量 */
  returnsQty = undefined;

  /** sku */
  sku = "";

  /** 未退数量 */
  unReturnsQty = undefined;
}

class OrderSkuItemRequestDto {
  /** platform */
  platform = "";

  /** spOrderNo */
  spOrderNo = "";
}

class OrderSkuResponseDto {
  /** items */
  items = [];

  /** spOrderNo */
  spOrderNo = "";
}

class OrderSyncSystemOrderRemarkDto {
  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 系统订单备注 */
  remark = "";

  /** 系统订单编号 */
  soOrderNo = "";

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 更新时间 */
  updateTime = "";
}

class OrderUpdatePriceDto {
  /** financeTotalTaxAmount */
  financeTotalTaxAmount = undefined;

  /** financeTotalUnTaxAmount */
  financeTotalUnTaxAmount = undefined;

  /** itemDtoList */
  itemDtoList = [];

  /** soOrderNo */
  soOrderNo = "";

  /** spPayAmount */
  spPayAmount = undefined;

  /** spSalesPrice */
  spSalesPrice = undefined;

  /** spTradingPrice */
  spTradingPrice = undefined;
}

class OrderUpdatePriceItemDto {
  /** itemPrice */
  itemPrice = undefined;

  /** itemTotalPrice */
  itemTotalPrice = undefined;

  /** itemTradingPrice */
  itemTradingPrice = undefined;

  /** sku */
  sku = "";
}

class OutPlanStatusResultDto {
  /** 发货时间 */
  deliveryTime = "";

  /** 错误信息 */
  errorMessage = "";

  /** 仓库首次完成拣货时间 */
  finishPickingTime = "";

  /** 仓库首次拣货时间 */
  firstPickUpTime = "";

  /** 是否历史订单 默认false，不是历史订单不需要传该参数，是则传ture */
  historyOrder = false;

  /** 是否推送运单号至平台后台 1：是 0：否 */
  isPushFlag = undefined;

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流面单文件路径 */
  logisticsLabelPath = "";

  /** 运费 */
  logisticsPrice = undefined;

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** // 物流状态 10:未发运 20:已发运 30:已妥投 40:已退回 */
  logisticsStatus = undefined;

  /** 出库计划单号 */
  opno = "";

  /** 平台邮寄方式 */
  platformPost = "";

  /** 退货单承运商 */
  reCarrier = "";

  /** 退货单跟踪号 */
  reTrackingNo = "";

  /** sku发运结果 */
  skuShippedResultDtoList = [];

  /** OMS订单号 */
  soOrderNo = "";

  /** 来源单号(包裹单号) */
  sourceNo = "";

  /** 状态 0:待匹配 10:缺货 20:匹配失败 25:齐货 30:待物流申请 40:申请失败 50:已推送 60:已发运 70:异常作废  80:派送失败 */
  status = undefined;

  /** 跟踪地址 */
  traceAddress = "";

  /** 最终跟踪号 */
  trackingNo = "";

  /** 唯一标识 */
  uniqueKey = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";

  /** 出库重量 */
  weight = undefined;
}

class PackageExchangeGoodsDto {
  /** 换货列表 */
  exchangeGoodsItemDtos = [];

  /** 包裹单号 */
  opNo = "";

  /** 包裹单item号 */
  pio = "";

  /** 数量 */
  qty = undefined;

  /** 系统订单号 */
  soOrderNo = "";
}

class PackageExchangeGoodsItemRpcDto {
  /** 数量 */
  qty = undefined;

  /** 换货列表 */
  sku = "";
}

class PackageExchangeGoodsRpcDto {
  /** 换货列表 */
  exchangeGoodsItemDtos = [];

  /** 包裹单号 */
  opNo = "";

  /** 包裹单item号 */
  pio = "";

  /** 数量 */
  qty = undefined;

  /** 系统订单号 */
  soOrderNo = "";
}

class PackageItemParamDto {
  /** pioType */
  pioType = "";

  /** 数量 */
  quantity = undefined;

  /** sku */
  sku = "";

  /** 系统订单商品编号 */
  soItemNo = "";

  /** 平台订单商品编号 */
  spItemNo = "";
}

class PackageItemParamRpcDto {
  /** pioType */
  pioType = "";

  /** 数量 */
  quantity = undefined;

  /** sku */
  sku = "";

  /** 系统订单商品编号 */
  soItemNo = "";

  /** 平台订单商品编号 */
  spItemNo = "";
}

class PackageItemResponseRpcDto {
  /** 锁定数量（齐货数量） */
  lockQty = undefined;

  /** 锁定仓库 */
  lockWarehouse = "";

  /** 锁定仓库编码 */
  lockWarehouseCode = "";

  /** 包裹item编号 */
  pioItemNo = "";

  /** 包裹单item类型 */
  pioType = undefined;

  /** 数量 */
  qty = undefined;

  /** 发运状态 1:待发运 2:已发运 3:部分发运 */
  shipmentStatus = undefined;

  /** sku */
  sku = "";

  /** 系统订单商品号 */
  soItemNo = "";

  /** 平台订单商品号 */
  spItemNo = "";

  /** 交易号 */
  transactionId = "";
}

class Page {
  /** countId */
  countId = "";

  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** maxLimit */
  maxLimit = undefined;

  /** optimizeCountSql */
  optimizeCountSql = false;

  /** orders */
  orders = [];

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PaymentPeriodAndDepositRatioResponseDto {
  /** depositRatios */
  depositRatios = [];

  /** paymentPeriods */
  paymentPeriods = [];
}

class PlatformOrderDto {
  /** 买家ID/编号 */
  buyerCode = "";

  /** 买家邮箱 */
  buyerEmail = "";

  /** 买家留言 */
  buyerMessage = "";

  /** 买家指定物流 */
  buyerSpecifyLogistics = "";

  /** 客户id */
  customerId = "";

  /** 客户名称 */
  customerName = "";

  /** 派送方式 */
  deliveryMethod = undefined;

  /** 折扣码 */
  discountCode = "";

  /** 财务税率 */
  financeTaxRate = undefined;

  /** 标识状态 */
  identityStatus = "";

  /** 物流运费 */
  logisticsShipping = undefined;

  /** 发运方式 1.平台配送 2.卖家配送 */
  orderShipmentMethod = undefined;

  /** 订单类型 1.平台订单 2.企业订单 */
  orderType = undefined;

  /** 订单付款方式 */
  payMethod = "";

  /** 订单关联关系 */
  platformOrderRelationDto = new PlatformOrderRelationDto();

  /** 是否有父订单关联 */
  relation = false;

  /** 收件人地址1 */
  shippingAddress1 = "";

  /** 收件人地址2 */
  shippingAddress2 = "";

  /** 收件人城市 */
  shippingCity = "";

  /** 收件人所在国家 */
  shippingCountry = "";

  /** 收件人所在国家编码 */
  shippingCountryCode = "";

  /** 收件人邮箱 */
  shippingEmail = "";

  /** 收件人名字 */
  shippingName = "";

  /** 收件人电话 */
  shippingPhone = "";

  /** 收件人邮编 */
  shippingPostCode = "";

  /** 收件人州或省 */
  shippingStateOrProvince = "";

  /** 收件人州或省编码 */
  shippingStateOrProvinceCode = "";

  /** 收件人纳税号 */
  shippingTaxid = "";

  /** 平台订单佣金 */
  spCommission = undefined;

  /** 平台订单币种 */
  spCurrency = "";

  /** 平台订单优惠额 */
  spDiscount = undefined;

  /** 平台订单店铺 */
  spMarketCode = "";

  /** 平台订单店铺名称 */
  spMarketName = "";

  /** 平台订单id（平台生成） */
  spOrderId = "";

  /** 平台订单号（客服填写,如果没有则等于spOrderId） */
  spOrderNo = "";

  /** 订单付款状态 */
  spOrderPayStatus = "ACCOUNT_PAID";

  /** 订单状态 */
  spOrderStatus = "CANCELED";

  /** 平台订单下单时间 */
  spOrderTime = "";

  /** 平台订单更新时间 */
  spOrderUpdateTime = "";

  /** 平台订单实收款 */
  spPayAmount = undefined;

  /** 平台订单支付时间 */
  spPaymentDate = "";

  /** 平台订单来源平台 */
  spPlatform = "";

  /** 平台订单退款金额 */
  spRefundAmount = undefined;

  /** 平台订单备注 */
  spRemark = "";

  /** 平台订单销售价 */
  spSalesPrice = undefined;

  /** 平台订单运费 */
  spShipping = undefined;

  /** 平台订单发货状态 1未发货 2部分发货 3已发货 */
  spShippingStatus = undefined;

  /** 店铺对应的站点 国家二字节码 例如:UK */
  spSite = "";

  /** 平台订单状态 */
  spStatus = "";

  /** 平台订单税费 */
  spTaxes = undefined;

  /** 平台订单交易价 */
  spTradingPrice = undefined;

  /** 贸易主体编码 */
  tradeCompanyCode = "";

  /** 贸易主体名称 */
  tradeCompanyName = "";

  /** 交易ID */
  transactionId = "";
}

class PlatformOrderItemDto {
  /** 佣金 */
  commission = undefined;

  /** 优惠价 */
  discount = undefined;

  /** 包装费 */
  giftWrapPrice = undefined;

  /** 包装税费 */
  giftWrapTax = undefined;

  /** 商品销售价格 */
  itemPrice = undefined;

  /** 商品价格的税费 */
  itemTax = undefined;

  /** 商品总价格 */
  itemTotalPrice = undefined;

  /** 商品交易价格 */
  itemTradingPrice = undefined;

  /** 销售sku（平台生成） */
  platformSku = "";

  /** 销售sku名字 */
  platformSkuName = "";

  /** 销售sku标题 */
  platformSkuTitle = "";

  /** 购买数量 */
  quantity = undefined;

  /** 运费折扣 */
  shippingDiscount = undefined;

  /** 运费 */
  shippingPrice = undefined;

  /** 运费税费 */
  shippingTax = undefined;

  /** 平台订单商品编号 */
  spItemNo = "";

  /** 平台商品发货状态,平台商品发货状态 1未发货 2已发货 */
  spItemShipping = undefined;

  /** 平台订单商品id */
  spProductId = "";

  /** 平台商品退款金额 */
  spRefundAmount = undefined;

  /** 平台商品退货数量 */
  spReturnNumber = undefined;

  /** 交易号 */
  transactionId = "";
}

class PlatformOrderRelationDto {
  /** 业务类型 */
  businessType = undefined;

  /** 源订单店铺编号 */
  parentSpMarketCode = "";

  /** 源订单编号 */
  parentSpOrderId = "";
}

class ProductLabelResponseDto {
  /** fnsku */
  fnsku = "";

  /** 店铺 */
  fnskuShopName = "";

  /** id */
  id = undefined;

  /** 1全平台 2店铺映射 */
  mapperType = undefined;

  /** msku */
  msku = "";

  /** 平台 */
  platform = "";

  /** 店铺编码Code */
  shopCode = "";

  /** 店铺 */
  shopName = "";

  /** sku */
  sku = "";

  /** 产品标签CN */
  skuNameCn = "";

  /** 产品标签EN */
  skuNameEn = "";
}

class RefundOrderDvo {
  /** 取消退款时间 */
  cancelRefundTime = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 退款生效时间 */
  effectiveRefundTime = "";

  /** 退款金额 */
  refundAmount = undefined;

  /** 退款单来源 0:erp 1:callcenter */
  refundChannel = undefined;

  /** 退款英文原因 */
  refundEnReason = "";

  /** 退款方法: 1:产品退款 2:仅退邮费 */
  refundMethod = undefined;

  /** 退款单号 */
  refundNo = "";

  /** 退款原因 */
  refundReason = "";

  /** 退款原因Code */
  refundReasonCode = "";

  /** 退款状态 */
  refundStatus = undefined;

  /** 系统订单生成方式 1:平台传输生成 2:系统内创建 */
  soBuildAction = undefined;

  /** 系统订单号 */
  soOrderNo = "";

  /** 订单状态 */
  soStatus = undefined;

  /** 店铺 */
  spMarketName = "";

  /** 平台单号 */
  spOrderNo = "";

  /** 平台 */
  spPlatform = "";

  /** 订单总金额 */
  spTradingPrice = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 更新时间 */
  updateTime = "";
}

class RefundOrderOperationDto {
  /** 退款单号 */
  refundNo = "";
}

class RejectBillCallBackRpcDto {
  /** 退货售后单号 */
  mrbNo = "";

  /** 入库SKU明细 */
  skuList = [];
}

class RejectBillDvo {
  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 是否跨三方仓退货 1是 0不是 */
  crossBorderReturns = false;

  /** 多订单退货售后单号 */
  directorMrbNo = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 退货英文原因 */
  itemReturnEnReason = "";

  /** 退货原因 */
  itemReturnReason = "";

  /** 退货原因Code */
  itemReturnReasonCode = "";

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 逆向物流标志 */
  logisticsFlag = false;

  /** 实际退货时间 */
  mrbActualReturnTime = "";

  /** 取消退货时间 */
  mrbCancelReturnTime = "";

  /** 退款单来源 */
  mrbChannel = undefined;

  /** 售后单号 */
  mrbNo = "";

  /** 退货状态 */
  mrbStatus = undefined;

  /** 跟踪单号 */
  mrbTrackingNo = "";

  /** 平台退货原因 */
  platformReturnReason = "";

  /** 退货类型：1退货 2换货 3维修 */
  refundType = undefined;

  /** SO单号 */
  soOrderNo = "";

  /** 订单状态 */
  soStatus = undefined;

  /** 店铺 */
  spMarketCode = "";

  /** 店铺 */
  spMarketName = "";

  /** 平台单号 */
  spOrderNo = "";

  /** 平台 */
  spPlatform = "";

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 更新时间 */
  updateTime = "";
}

class RejectBillItemCallBackRpcDto {
  /** 入库数量 */
  alreadyReturnQuantity = undefined;

  /** sku */
  sku = "";
}

class RejectBillOperationDto {
  /** 售后单号 */
  mrbNo = "";
}

class RejectBillPageDto {
  /** 页数 */
  current = undefined;

  /** 条数 */
  size = undefined;

  /** 平台单号 */
  spOrderNo = "";

  /** 平台 */
  spPlatform = "";
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new AsMaterialRejectBillCancelDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResubmitPackageRequestDto {
  /** 多渠道订单是否不使用亚马逊物流运送 1:是 0:否 */
  blockAmazonLogisticFlag = undefined;

  /** 多渠道订单是否使用无标记箱子发货 1:是 0:否 */
  onlyBlankBoxesFlag = undefined;

  /** 包裹单号列表 */
  opNoList = [];

  /** 是否申请多渠道订单 1:是 0:否 */
  optionalIsMcf = undefined;

  /** 自选物流渠道 */
  optionalLogisticsChannel = "";

  /** 自选物流渠道编码 */
  optionalLogisticsChannelCode = "";

  /** 自选物流商 */
  optionalLogisticsCompany = "";

  /** 自选物流商编码 */
  optionalLogisticsCompanyCode = "";

  /** 自选发货仓库 */
  optionalLogisticsDeliveryWarehouse = "";

  /** 自选发货仓库编码 */
  optionalLogisticsDeliveryWarehouseCode = "";

  /** 自选店铺编号 */
  optionalShopKey = "";

  /** 自选店铺名称 */
  optionalShopName = "";
}

class ResubmitPackageRpcDto {
  /** 包裹单号列表 */
  opNoList = [];

  /** 是否申请多渠道订单 1:是 0:否 */
  optionalIsMcf = undefined;

  /** 自选物流渠道 */
  optionalLogisticsChannel = "";

  /** 自选物流渠道编码 */
  optionalLogisticsChannelCode = "";

  /** 自选物流商 */
  optionalLogisticsCompany = "";

  /** 自选物流商编码 */
  optionalLogisticsCompanyCode = "";

  /** 自选发货仓库 */
  optionalLogisticsDeliveryWarehouse = "";

  /** 自选发货仓库编码 */
  optionalLogisticsDeliveryWarehouseCode = "";

  /** 自选店铺编号 */
  optionalShopKey = "";

  /** 自选店铺名称 */
  optionalShopName = "";

  /** 是否特批发货 1:是 0:否 */
  specialShipping = undefined;
}

class ReturnReasonEnumResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 平台退货原因 */
  platformReturnReason = "";

  /** 平台订单来源平台 */
  spPlatform = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SellerSkuToMapRpcDto {
  /** msku */
  msku = "";

  /** 修改前msku */
  oldMsku = "";

  /** 修改前店铺编码 */
  oldShopCode = "";

  /** 修改前店铺 */
  oldShopName = "";

  /** 操作 */
  operate = "";

  /** 平台 */
  platform = "";

  /** 产品名称 */
  productName = "";

  /** 店铺编码code */
  shopCode = "";

  /** 店铺 */
  shopName = "";

  /** sku */
  sku = "";
}

class SkuPriceRequestDto {
  /** msku */
  msku = "";

  /** shopKey */
  shopKey = "";
}

class SkuShippedResultDto {
  /** sku实际发运数量 */
  shippedQty = undefined;

  /** sku编号 */
  skuNo = "";
}

class SystemOrderContractRequestDto {
  /** 提单类型：【1 电放，2 正本，3 无需提单】 */
  billType = undefined;

  /** 是否出产地证 1 是，0 否 */
  certificateOfOrigin = undefined;

  /** 国家 */
  country = "";

  /** 国家代码 */
  countryCode = "";

  /** 是否报关 1 是，0 否 */
  customsDeclaration = undefined;

  /** 目的地地址 */
  destinationAddress = "";

  /** 发票日期 */
  invoiceDate = "";

  /** 发票号 */
  invoiceNumber = "";

  /** 运输方式：【1 龙舟空运，2 龙舟海运，3 龙舟快船，4 龙舟散货，10 普通空运，20 普通海运，25 普海海运-OA联盟，30 快船，40 铁路，50 卡车，60 快递】 */
  logisticsType = undefined;

  /** 包裹单号 */
  opNo = "";

  /** 电话 */
  phone = "";

  /** 协议合同号 */
  protocolContractNumber = "";

  /** 收件人 */
  recipient = "";

  /** 备注 */
  remark = "";

  /** 货运联系方式 */
  shippingContact = "";

  /** 唛头 */
  shippingMark = "";

  /** 贸易条款：【FOB/CFR/CIF/CPT/CZP/DAF/DES/DEQ/DDW/DDP/EXW】 */
  tradeTerms = "";
}

class SystemOrderContractResponseDto {
  /** 提单类型：【1 电放，2 正本，3 无需提单】 */
  billType = undefined;

  /** 是否出产地证 1 是，0 否 */
  certificateOfOrigin = undefined;

  /** 国家 */
  country = "";

  /** 国家代码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 是否报关 1 是，0 否 */
  customsDeclaration = undefined;

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 目的地地址 */
  destinationAddress = "";

  /** id */
  id = undefined;

  /** 发票日期 */
  invoiceDate = "";

  /** 发票号 */
  invoiceNumber = "";

  /** 乐观锁 */
  lockVersion = undefined;

  /** 运输方式：【1 龙舟空运，2 龙舟海运，3 龙舟快船，4 龙舟散货，10 普通空运，20 普通海运，25 普海海运-OA联盟，30 快船，40 铁路，50 卡车，60 快递】 */
  logisticsType = undefined;

  /** 包裹单号 */
  opNo = "";

  /** 电话 */
  phone = "";

  /** 协议合同号 */
  protocolContractNumber = "";

  /** 收件人 */
  recipient = "";

  /** 备注 */
  remark = "";

  /** 货运联系方式 */
  shippingContact = "";

  /** 唛头 */
  shippingMark = "";

  /** 系统订单编号 */
  soOrderNo = "";

  /** 贸易条款：【FOB/CFR/CIF/CPT/CZP/DAF/DES/DEQ/DDW/DDP/EXW】 */
  tradeTerms = "";

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 更新时间 */
  updateTime = "";
}

class SystemOrderContractResponseRpcDto {
  /** 提单类型：【1 电放，2 正本，3 无需提单】 */
  billType = undefined;

  /** 是否出产地证 1 是，0 否 */
  certificateOfOrigin = undefined;

  /** 国家 */
  country = "";

  /** 国家代码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 是否报关 1 是，0 否 */
  customsDeclaration = undefined;

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 目的地地址 */
  destinationAddress = "";

  /** id */
  id = undefined;

  /** 发票日期 */
  invoiceDate = "";

  /** 发票号 */
  invoiceNumber = "";

  /** 乐观锁 */
  lockVersion = undefined;

  /** 运输方式：【1 龙舟空运，2 龙舟海运，3 龙舟快船，4 龙舟散货，10 普通空运，20 普通海运，25 普海海运-OA联盟，30 快船，40 铁路，50 卡车，60 快递】 */
  logisticsType = undefined;

  /** 包裹单号 */
  opNo = "";

  /** 电话 */
  phone = "";

  /** 协议合同号 */
  protocolContractNumber = "";

  /** 收件人 */
  recipient = "";

  /** 备注 */
  remark = "";

  /** 货运联系方式 */
  shippingContact = "";

  /** 唛头 */
  shippingMark = "";

  /** sku明细 */
  skuItemList = [];

  /** SO单币种 */
  soCurrency = "";

  /** 系统订单编号 */
  soOrderNo = "";

  /** SO单收件人地址1 */
  soShippingAddress1 = "";

  /** SO单收件人 */
  soShippingName = "";

  /** SO单收件人电话 */
  soShippingPhone = "";

  /** 平台单号 */
  spOrderNo = "";

  /** 主体编码 */
  tradeCompanyCode = "";

  /** 主体名称 */
  tradeCompanyName = "";

  /** 贸易条款：【FOB/CFR/CIF/CPT/CZP/DAF/DES/DEQ/DDW/DDP/EXW】 */
  tradeTerms = "";

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 更新时间 */
  updateTime = "";
}

class SystemOrderContractSkuItemResponseDto {
  /** 销售单价 */
  price = undefined;

  /** sku */
  sku = "";
}

class SystemOrderCorrelationDto {
  /** 关联订单号 */
  childSoOrderNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 被关联订单号 */
  parentSoOrderNo = "";

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 更新时间 */
  updateTime = "";
}

class SystemOrderCorrelationRpcDto {
  /** 关联订单号 */
  childSoOrderNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 被关联订单号 */
  parentSoOrderNo = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SystemOrderDetailResponseDto {
  /** 手工单关联订单 */
  associated = "";

  /** 关联子订单 */
  associatedOrder = [];

  /** 买家ID/编号 */
  buyerCode = "";

  /** 买家邮箱 */
  buyerEmail = "";

  /** 创建人 */
  createBy = "";

  /** 客户Id */
  customerName = "";

  /** 财务税率（目前只有toB） */
  financeTaxRate = undefined;

  /** 财务税额总额（目前只有toB） */
  financeTotalTaxAmount = undefined;

  /** 财务未税总额（目前只有toB） */
  financeTotalUnTaxAmount = undefined;

  /** 包装费 */
  giftWrapPrice = undefined;

  /** 包装税费 */
  giftWrapTax = undefined;

  /** 订单明细 */
  itemDetailResponseDtoList = [];

  /** 订单来源类型 1.线下销售订单，2.线下销售订单 3.外包系统订单 4.wfs订单 5.京配订单 6.京东自营订单 */
  orderType = undefined;

  /** 地址1 */
  shippingAddress1 = "";

  /** 地址2 */
  shippingAddress2 = "";

  /** 城市 */
  shippingCity = "";

  /** 国家 */
  shippingCountry = "";

  /** 国家简称 */
  shippingCountryCode = "";

  /** 运费折扣 */
  shippingDiscount = undefined;

  /** 邮箱 */
  shippingEmail = "";

  /** 收件人 */
  shippingName = "";

  /** 电话 */
  shippingPhone = "";

  /** 邮编 */
  shippingPostCode = "";

  /** 订单运费 */
  shippingPrice = undefined;

  /** 州 */
  shippingStateOrProvince = "";

  /** 州简称 */
  shippingStateOrProvinceCode = "";

  /** 运费税费 */
  shippingTax = undefined;

  /** 售后状态 */
  soAfterSaleStatus = undefined;

  /** 系统订单生成方式 1:平台传输生成 2:系统内创建 */
  soBuildAction = undefined;

  /** 订单编号 */
  soOrderNo = "";

  /** 订单状态 */
  soOrderStatus = undefined;

  /** 付款状态 */
  soPayStatus = undefined;

  /** 系统订单退款金额 */
  soRefundAmount = undefined;

  /** 平台备注 */
  soRemark = "";

  /** 子订单类型 1维修,2换货,3其他  */
  soSonStatus = undefined;

  /** 贸易主体编码 */
  soTradeCompanyCode = "";

  /** 交易主体名称 */
  soTradeCompanyName = "";

  /** 订单类型 */
  soType = undefined;

  /** 平台订单币种 */
  spCurrency = "";

  /** 折扣 */
  spDiscount = undefined;

  /** 店铺编码 */
  spMarketCode = "";

  /** 店铺 */
  spMarketName = "";

  /** 平台单号 */
  spOrderNo = "";

  /** 平台订单下单时间 */
  spOrderTime = "";

  /** 实收金额 */
  spPayAmount = undefined;

  /** 平台 */
  spPlatform = "";

  /** 退款金额 */
  spRefundAmount = undefined;

  /** 系统备注 */
  spRemark = "";

  /** 订单金额 */
  spSalesPrice = undefined;

  /** 平台税费 */
  spShipping = undefined;

  /** 支付金额 */
  spTradingPrice = undefined;

  /** 交易ID */
  transactionId = "";
}

class SystemOrderDto {
  /** 结算中心业务类型1正常 2补发 3重发 4测评 5改发 */
  arsBusinessType = undefined;

  /** 业务来源标识 1正常 2企业订单 */
  businessLogo = undefined;

  /** 业务类型 */
  businessType = undefined;

  /** 买家ID/编号 */
  buyerCode = "";

  /** 买家邮箱 */
  buyerEmail = "";

  /** 买家留言 */
  buyerMessage = "";

  /** 买家指定物流 */
  buyerSpecifyLogistics = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 平台订单币种 */
  currencyCode = "";

  /** 客户id */
  customerId = "";

  /** 客户信息id,主要用于线下销售订单 */
  customerName = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 派送方式,0:非自提，1:买家自提 */
  deliveryMethod = undefined;

  /** 折扣码 */
  discountCode = "";

  /** 财务税率（目前只有toB） */
  financeTaxRate = undefined;

  /** 财务税额总额（目前只有toB） */
  financeTotalTaxAmount = undefined;

  /** 财务未税总额（目前只有toB） */
  financeTotalUnTaxAmount = undefined;

  /** 仓库首次完成拣货时间 */
  finishPickingTime = "";

  /** 仓库首次实际出货时间 */
  firstActualDeliveryTime = "";

  /** 仓库首次拣货时间 */
  firstPickUpTime = "";

  /** 0:不是历史订单 1历史订单 */
  historyOrder = false;

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 物流运费 */
  logisticsShipping = undefined;

  /** 0：不是补差价订单 1：是补差价订单 */
  offsetOrder = false;

  /** 补差源单号-ARS获取 */
  offsetOriginalOrderNumber = "";

  /** 发运方式 1:平台配送 2:卖家自配送 */
  orderShipmentMethod = undefined;

  /** 平台大类 1:平台订单,2:企业订单 */
  orderType = undefined;

  /** 关联的原订单号 */
  originalOrderNumber = "";

  /** 付款方式 */
  payMethod = "";

  /** 平台订单号 */
  platformOrderNumber = "";

  /** 系统订单状态:0未付款 1待审核  2待发货 3缺货 4物流问题 5发货问题 6部分发货 7已完成 8已取消 9风险订单 10已拦截  11异常确认 12派送失败 13已签收 */
  platformShippingStatus = undefined;

  /** 采购订单号-ARS获取 */
  poOrderNumber = "";

  /** 销售订单号 */
  salesOrderNumber = "";

  /** 平台店铺相关ID */
  sellerId = "";

  /** 收件人地址1 */
  shippingAddress1 = "";

  /** 收件人地址2 */
  shippingAddress2 = "";

  /** 收件人城市 */
  shippingCity = "";

  /** 收件人所在国家 */
  shippingCountry = "";

  /** 收件人所在国家编码 */
  shippingCountryCode = "";

  /** 收件人邮箱 */
  shippingEmail = "";

  /** 收件人名字 */
  shippingName = "";

  /** 收件人电话 */
  shippingPhone = "";

  /** 收件人邮编 */
  shippingPostCode = "";

  /** 收件人州或省 */
  shippingStateOrProvince = "";

  /** 收件人州或省编码 */
  shippingStateOrProvinceCode = "";

  /** 收件人纳税号 */
  shippingTaxid = "";

  /** 系统订单售后状态 1正常 2退款 3部分退款 4退货 5部分退货 */
  soAfterSaleStatus = undefined;

  /** 系统订单生成方式 1:平台传输生成 2:系统内创建 */
  soBuildAction = undefined;

  /** 系统订单取消原因 */
  soCancelReason = "";

  /** 系统订单异常原因 */
  soErrorCause = "";

  /** 系统订单拦截原因 */
  soInterceptReson = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 系统订单付款状态 0未付款 1已付款 2部分退款 3已退款 */
  soPayStatus = undefined;

  /** 系统订单退款金额 */
  soRefundAmount = undefined;

  /** 系统订单备注 */
  soRemark = "";

  /** 系统订单状态:0未付款 1待审核  2待发货 3缺货 4物流问题 5发货问题 6部分发货 7已完成 8已取消 9风险订单 10已拦截  11异常确认 12派送失败 13已签收 */
  soStatus = undefined;

  /** 贸易主体编码 */
  soTradeCompanyCode = "";

  /** 贸易主体名称 */
  soTradeCompanyName = "";

  /** 系统订单类型 1正常 2补发 3重发 4测评 5改发 6换货 7维修 */
  soType = undefined;

  /** 订单总折扣金额，取自上游订单系统明细折扣金额汇总-ARS获取 */
  sourceDiscountAmount = undefined;

  /** 销售订单主键ID */
  sourceHeaderId = undefined;

  /** 源订单金额，取自上游订单系统的明细金额汇总-ARS获取 */
  sourceOrderAmount = undefined;

  /** 订单额外费用，取自上游订单的运费，例如shopify运费结算在单上-ARS获取 */
  sourceShippingAmount = undefined;

  /** 来源税额 */
  sourceTaxAmount = undefined;

  /** 平台订单佣金 */
  spCommission = undefined;

  /** 平台订单币种 */
  spCurrency = "";

  /** 平台订单优惠额 */
  spDiscount = undefined;

  /** 平台订单店铺 */
  spMarketCode = "";

  /** 平台订单店铺名称 */
  spMarketName = "";

  /** 平台订单id（平台生成） */
  spOrderId = "";

  /** 平台订单号（客服填写） */
  spOrderNo = "";

  /** 平台订单下单时间 */
  spOrderTime = "";

  /** 平台订单更新时间 */
  spOrderUpdateTime = "";

  /** 平台订单实收款 */
  spPayAmount = undefined;

  /** 平台订单支付时间 */
  spPaymentDate = "";

  /** 平台订单来源平台 */
  spPlatform = "";

  /** 平台订单退款金额 */
  spRefundAmount = undefined;

  /** 平台订单备注 */
  spRemark = "";

  /** 平台订单销售价 */
  spSalesPrice = undefined;

  /** 平台订单运费 */
  spShipping = undefined;

  /** 平台订单发货状态 1未发货 2部分发货 3已发货 */
  spShippingStatus = undefined;

  /** 平台站点 */
  spSite = "";

  /** 平台订单状态 */
  spStatus = "";

  /** 平台订单税费 */
  spTaxes = undefined;

  /** 平台订单交易价 */
  spTradingPrice = undefined;

  /** 订单总运费，由明细的运费金额累计后得出-ARS获取 */
  sumShippingAmount = undefined;

  /** 同步结算中心信息 */
  syncMsg = "";

  /** 同步结算中心状态 0待同步 1同步成功 2同步失败 */
  syncStatus = undefined;

  /** 税额 */
  taxAmount = undefined;

  /** 含税金额 */
  taxIncludedAmount = undefined;

  /** 订单总量 */
  totalOrder = undefined;

  /** 贸易主体编码 */
  tradingCompanyCode = "";

  /** 贸易主体名称 */
  tradingCompanyName = "";

  /** 国家编码 */
  tradingCountryCode = "";

  /** 国家名称 */
  tradingCountryName = "";

  /** 平台订单来源平台 */
  tradingPlatformCode = "";

  /** 平台订单店铺 */
  tradingShopCode = "";

  /** 平台订单店铺名称 */
  tradingShopName = "";

  /** 平台站点 */
  tradingSiteCode = "";

  /** 交易ID */
  transactionId = "";

  /** 未税金额 */
  untaxedAmount = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 更新时间 */
  updateTime = "";
}

class SystemOrderHeaderDto {
  /** 是否发运推送 */
  needShipping = false;

  /** 系统订单关联关系信息 */
  systemOrderCorrelationDto = new SystemOrderCorrelationDto();

  /** 系统订单头信息 */
  systemOrderDto = new SystemOrderDto();

  /** 系统订单明细信息 */
  systemOrderItemDtoList = [];

  /** 包裹单发货信息 */
  systemOrderPackageDeliveryInformationDto = new SystemOrderPackageDeliveryInformationDto();

  /** 包裹信息 */
  systemOrderPackageDtoList = [];

  /** 系统订单备注记录信息 */
  systemOrderRemarkDto = new SystemOrderRemarkDto();
}

class SystemOrderItemDetailResponseDto {
  /** 财务税额总额（目前只有toB） */
  financeTotalTaxAmount = undefined;

  /** 财务未税总额（目前只有toB） */
  financeTotalUnTaxAmount = undefined;

  /** 财务未税单价（目前只有toB） */
  financeUnTaxAmount = undefined;

  /** 包装费 */
  giftWrapPrice = undefined;

  /** 包装税费 */
  giftWrapTax = undefined;

  /** 图片 */
  image = "";

  /** 商品支付价格 */
  itemPayPrice = undefined;

  /** 售价 */
  itemPrice = undefined;

  /** 商品总价格 */
  itemTotalPrice = undefined;

  /** 商品交易价格 */
  itemTradingPrice = undefined;

  /** SKU */
  msku = "";

  /** 数量 */
  qty = undefined;

  /** 是否翻新 0否 1是 */
  renovateSku = undefined;

  /** 运费折扣 */
  shippingDiscount = undefined;

  /** 订单运费 */
  shippingPrice = undefined;

  /** 运费税费 */
  shippingTax = undefined;

  /** SKU */
  sku = "";

  /** 商品名称 */
  skuName = "";

  /** 币种 */
  spCurrency = "";

  /** 平台订单item Id */
  spItemNo = "";

  /** 平台商品Id */
  spProductId = "";

  /** 交易号 */
  transactionId = "";
}

class SystemOrderItemDto {
  /** 佣金 */
  commission = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 优惠价 */
  discount = undefined;

  /** 换货原SKU */
  exchangeCategorySku = "";

  /** 财务商品支付单价 */
  financeItemPayPrice = undefined;

  /** 财务商品支付总价格 */
  financeItemTotalPayPrice = undefined;

  /** 财务税率（目前只有toB）-oms需要新增 */
  financeTaxRate = undefined;

  /** 财务税额总额（目前只有toB） */
  financeTotalTaxAmount = undefined;

  /** 财务未税总额（目前只有toB） */
  financeTotalUnTaxAmount = undefined;

  /** 财务未税单价（目前只有toB） */
  financeUnTaxAmount = undefined;

  /** 包装费 */
  giftWrapPrice = undefined;

  /** 包装税费 */
  giftWrapTax = undefined;

  /** 商品高度 cm */
  height = undefined;

  /** id */
  id = undefined;

  /** sku图片地址 */
  image = "";

  /** 商品销售价格 */
  itemPrice = undefined;

  /** 商品价格的税费 */
  itemTax = undefined;

  /** 商品总价格 */
  itemTotalPrice = undefined;

  /** 商品交易价格 */
  itemTradingPrice = undefined;

  /** 商品长度 cm */
  length = undefined;

  /** 销售订单行号 */
  lineNumber = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 销售sku */
  mskuCode = "";

  /** 销售sku */
  platformSku = "";

  /** 销售sku名字 */
  platformSkuName = "";

  /** 销售sku标题 */
  platformSkuTitle = "";

  /** 购买数量 */
  quantity = undefined;

  /** 记录上游的item_trading_price-商品交易价格 */
  recordItemTradingPrice = undefined;

  /** 商品应收金额,根据 商品对账是否需含税 判断，如是则获取 商品含税支付单价，否则获取使用 商品未税支付单价 */
  recordReceivableUnitPrice = undefined;

  /** 商品其他费用总金额,商品包装费金额 */
  recordTotalAdditionalFees = undefined;

  /** 商品总折扣金额,商品促销折扣金额+商品运费折扣金额 */
  recordTotalDiscountAmount = undefined;

  /** 商品应收金额,根据 商品对账是否需含税 判断，如是则获取 商品含税支付单价，否则获取使用 商品未税支付单价 */
  recordTotalReceivableAmount = undefined;

  /** 商品总运费金额,ARS将明细上的运费和表头上订单额外运费进行分摊累计；计算逻辑为：商品总运费金额=商品收取运费金额 + (商品销售金额/订单原金额)*额外运费； */
  recordTotalShippingCost = undefined;

  /** 商品总税额,商品税费+商品包装税费金额+商品运费税费金额 */
  recordTotalTaxAmount = undefined;

  /** 商品未税支付单价,商品未税支付金额/数量 */
  recordUnitPrice = undefined;

  /** 销售金额 */
  salesAmount = undefined;

  /** 购买数量 */
  salesQuantity = undefined;

  /** 运费折扣 */
  shippingDiscount = undefined;

  /** 运费 */
  shippingPrice = undefined;

  /** 运费税费 */
  shippingTax = undefined;

  /** 实际sku */
  sku = "";

  /** 品类 -ARS自行获取 */
  skuCategory = "";

  /** 实际sku */
  skuCode = "";

  /** 实际sku名称 */
  skuName = "";

  /** 系统订单商品编号 */
  soItemNo = "";

  /** 系统订单编号 */
  soOrderNo = "";

  /** 明细行促销折扣，部分平台例如亚马逊、沃尔玛有提供，TOB的也需要提供（折扣金额=原价含税金额/订单原价含税金额*折扣金额） */
  sourceDiscount = undefined;

  /** 明细行包装费 */
  sourceGiftWrapPrice = undefined;

  /** 明细商品包装税费金额 */
  sourceGiftWrapTax = undefined;

  /** 来源销售订单头ID */
  sourceHeaderId = undefined;

  /** 上游税费，明细行税额或税费，部分平台例如亚马逊有提供税费，TOB的也需要提供(税额=折扣后含税金额-折扣后不税金额)； */
  sourceItemTax = undefined;

  /** 来源销售订单行ID */
  sourceLineId = undefined;

  /** 明细行运费折扣 */
  sourceShippingDiscount = undefined;

  /** 明细行上的运费，TOB的也需要提供； */
  sourceShippingPrice = undefined;

  /** 明细行运费税费 */
  sourceShippingTax = undefined;

  /** 币种 */
  spCurrency = "";

  /** 平台订单商品编码 */
  spItemNo = "";

  /** 平台商品发货状态 1未发货 2已发货 */
  spItemShipping = undefined;

  /** 平台订单号id */
  spOrderId = "";

  /** 平台订单商品id */
  spProductId = "";

  /** 平台商品退款金额 */
  spRefundAmount = undefined;

  /** 平台商品退货数量 */
  spReturnNumber = undefined;

  /** 税额 */
  taxAmount = undefined;

  /** 含税金额 */
  taxIncludedAmount = undefined;

  /** 商品对账是否需含税,目前收集到的信息仅亚马逊日本站点使用 含税金额，该字段的获取逻辑待定，如确定仅亚马逊JP站点使用建议写死 */
  taxIncludedFlag = false;

  /** 税率 */
  taxRate = undefined;

  /** 含税单价 */
  taxUnitPrice = undefined;

  /** 交易号 */
  transactionId = "";

  /** 单价 */
  unitPrice = undefined;

  /** 未税金额 */
  untaxedAmount = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 更新时间 */
  updateTime = "";

  /** 是否虚拟sku */
  virtualSku = undefined;

  /** 商品重量 g */
  weight = undefined;

  /** 商品宽度 cm */
  width = undefined;
}

class SystemOrderItemParamsDto {
  /** 销售sku */
  platformSku = "";

  /** 实际sku */
  sku = "";

  /** 系统订单商品编号 */
  soItemNo = "";

  /** 系统订单编号 */
  soOrderNo = "";

  /** 平台订单商品编码 */
  spItemNo = "";

  /** 平台订单id */
  spOrderId = "";
}

class SystemOrderItemResponseDto {
  /** 佣金 */
  commission = undefined;

  /** 优惠价 */
  discount = undefined;

  /** 商品支付价格 */
  financeItemPayPrice = undefined;

  /** 商品支付总价格 */
  financeItemTotalPayPrice = undefined;

  /** 商品高度 cm */
  height = undefined;

  /** sku图片地址 */
  image = "";

  /** 商品支付价格 */
  itemPayPrice = undefined;

  /** 商品销售价格 */
  itemPrice = undefined;

  /** 商品价格的税费 */
  itemTax = undefined;

  /** 商品总价格 */
  itemTotalPrice = undefined;

  /** 商品交易价格 */
  itemTradingPrice = undefined;

  /** 商品长度 cm */
  length = undefined;

  /** 销售sku */
  platformSku = "";

  /** 销售sku名字 */
  platformSkuName = "";

  /** 销售sku标题 */
  platformSkuTitle = "";

  /** 购买数量 */
  quantity = undefined;

  /** 是否翻新sku */
  renovateSku = undefined;

  /** 实际sku */
  sku = "";

  /** 实际sku名称 */
  skuName = "";

  /** 系统订单商品编号 */
  soItemNo = "";

  /** 系统订单编号 */
  soOrderNo = "";

  /** 币种 */
  spCurrency = "";

  /** 平台订单商品编码 */
  spItemNo = "";

  /** 平台商品发货状态 1未发货 2已发货 */
  spItemShipping = undefined;

  /** 平台订单号id */
  spOrderId = "";

  /** 平台订单商品id */
  spProductId = "";

  /** 平台商品退款金额 */
  spRefundAmount = undefined;

  /** 平台商品退货数量 */
  spReturnNumber = undefined;

  /** 交易号 */
  transactionId = "";

  /** 是否虚拟sku */
  virtualSku = undefined;

  /** 商品重量 g */
  weight = undefined;

  /** 商品宽度 cm */
  width = undefined;
}

class SystemOrderItemSaveParamsDto {
  /** 财务税额总额（目前只有toB） */
  financeTotalTaxAmount = undefined;

  /** 财务未税总额（目前只有toB） */
  financeTotalUnTaxAmount = undefined;

  /** 财务未税单价（目前只有toB） */
  financeUnTaxAmount = undefined;

  /** msku */
  msku = "";

  /** 价格 */
  price = undefined;

  /** 数量 */
  quantity = undefined;

  /** sku */
  sku = "";

  /** 平台订单item Id */
  spItemNo = "";

  /** 含税总额：含税单价 * 数量 */
  totalTaxPrice = undefined;
}

class SystemOrderItemSaveRpcDto {
  /** 价格 */
  price = undefined;

  /** 数量 */
  quantity = undefined;

  /** sku */
  sku = "";

  /** 平台订单item Id */
  spItemNo = "";
}

class SystemOrderPackageDeliveryInformationDto {
  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 门牌号 */
  houseNumber = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 收件人地址1 */
  opShippingAddress1 = "";

  /** 收件人地址2 */
  opShippingAddress2 = "";

  /** 收件人城市 */
  opShippingCity = "";

  /** 收件人所在国家 */
  opShippingCountry = "";

  /** 收件人所在国家编码 */
  opShippingCountryCode = "";

  /** 收件人邮箱 */
  opShippingEmail = "";

  /** 收件人名字 */
  opShippingName = "";

  /** 收件人电话 */
  opShippingPhone = "";

  /** 收件人邮编 */
  opShippingPostCode = "";

  /** 收件人州或省 */
  opShippingStateOrProvince = "";

  /** 收件人州或省编码 */
  opShippingStateOrProvinceCode = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 更新时间 */
  updateTime = "";
}

class SystemOrderPackageDeliveryRequestDto {
  /** 门牌号 */
  houseNumber = "";

  /** 发件人Eori */
  opEori = "";

  /** 收件人地址1 */
  opShippingAddress1 = "";

  /** 收件人地址2 */
  opShippingAddress2 = "";

  /** 收件人城市 */
  opShippingCity = "";

  /** 收件人所在国家 */
  opShippingCountry = "";

  /** 收件人所在国家编码 */
  opShippingCountryCode = "";

  /** 收件人邮箱 */
  opShippingEmail = "";

  /** 收件人名字 */
  opShippingName = "";

  /** 收件人电话 */
  opShippingPhone = "";

  /** 收件人邮编 */
  opShippingPostCode = "";

  /** 收件人州或省 */
  opShippingStateOrProvince = "";

  /** 收件人州或省编码 */
  opShippingStateOrProvinceCode = "";

  /** 发件人VAT */
  opVat = "";

  /** 系统订单号 */
  soOrderNo = "";
}

class SystemOrderPackageDeliveryResponseDto {
  /** 门牌号 */
  houseNumber = "";

  /** 发件人Eori */
  opEori = "";

  /** 收件人地址1 */
  opShippingAddress1 = "";

  /** 收件人地址2 */
  opShippingAddress2 = "";

  /** 收件人城市 */
  opShippingCity = "";

  /** 收件人所在国家 */
  opShippingCountry = "";

  /** 收件人所在国家编码 */
  opShippingCountryCode = "";

  /** 收件人邮箱 */
  opShippingEmail = "";

  /** 收件人名字 */
  opShippingName = "";

  /** 收件人电话 */
  opShippingPhone = "";

  /** 收件人邮编 */
  opShippingPostCode = "";

  /** 收件人州或省 */
  opShippingStateOrProvince = "";

  /** 收件人州或省编码 */
  opShippingStateOrProvinceCode = "";

  /** 发件人VAT */
  opVat = "";

  /** 系统订单号 */
  soOrderNo = "";
}

class SystemOrderPackageDeliveryRpcDto {
  /** 门牌号 */
  houseNumber = "";

  /** 收件人地址1 */
  opShippingAddress1 = "";

  /** 收件人地址2 */
  opShippingAddress2 = "";

  /** 收件人城市 */
  opShippingCity = "";

  /** 收件人所在国家 */
  opShippingCountry = "";

  /** 收件人所在国家编码 */
  opShippingCountryCode = "";

  /** 收件人邮箱 */
  opShippingEmail = "";

  /** 收件人名字 */
  opShippingName = "";

  /** 收件人电话 */
  opShippingPhone = "";

  /** 收件人邮编 */
  opShippingPostCode = "";

  /** 收件人州或省 */
  opShippingStateOrProvince = "";

  /** 收件人州或省编码 */
  opShippingStateOrProvinceCode = "";

  /** 系统订单号 */
  soOrderNo = "";
}

class SystemOrderPackageDeliveryRpcResponseDto {
  /** 门牌号 */
  houseNumber = "";

  /** 收件人地址1 */
  opShippingAddress1 = "";

  /** 收件人地址2 */
  opShippingAddress2 = "";

  /** 收件人城市 */
  opShippingCity = "";

  /** 收件人所在国家 */
  opShippingCountry = "";

  /** 收件人所在国家编码 */
  opShippingCountryCode = "";

  /** 收件人邮箱 */
  opShippingEmail = "";

  /** 收件人名字 */
  opShippingName = "";

  /** 收件人电话 */
  opShippingPhone = "";

  /** 收件人邮编 */
  opShippingPostCode = "";

  /** 收件人州或省 */
  opShippingStateOrProvince = "";

  /** 收件人州或省编码 */
  opShippingStateOrProvinceCode = "";

  /** 系统订单号 */
  soOrderNo = "";
}

class SystemOrderPackageDto {
  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 派送方式 0:非买家自提，1买家自提 */
  deliveryMethod = false;

  /** 财务税额总额（目前只有toB） */
  financeTotalTaxAmount = undefined;

  /** 财务含税总额（目前只有toB） */
  financeTotalTaxPrice = undefined;

  /** 财务未税总额（目前只有toB） */
  financeTotalUnTaxAmount = undefined;

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 发货时间 */
  logisticsDeliveryTime = "";

  /** 发货仓库 */
  logisticsDeliveryWarehouse = "";

  /** 发货仓库编码 */
  logisticsDeliveryWarehouseCode = "";

  /** 推送到PayPal状态 1未推送 2 推送成功 3 推送失败 */
  logisticsPaypalTracking = undefined;

  /** 物流运费 */
  logisticsPrice = undefined;

  /** 物流跟踪号 */
  logisticsTrackingNo = "";

  /** 物流跟踪链接地址 */
  logisticsTrackingUrl = "";

  /** 推送到平台状态 1未推送 2 推送成功 3 推送失败 */
  logisticsUpload = undefined;

  /** 推送到平台结果 */
  logisticsUploadMsg = "";

  /** 异常原因 */
  opErrorReason = "";

  /** 包裹单号 */
  opNo = "";

  /** 推送状态 1未推送 2推送成功 3推送失败 */
  opRpcStatus = undefined;

  /** 推送时间 */
  opRpcTime = "";

  /** 包裹状态 1:待审核 2:缺货 3:物流匹配失败 4:发货问题 5:已拦截 6:已发运 7:已取消 8:待发运  9:异常包裹 10:派送失败 11:部分发运 */
  opStatus = undefined;

  /** 包裹重量 */
  opWeight = undefined;

  /** 是否申请多渠道订单 1:是 0:否 */
  optionalIsMcf = false;

  /** 自选物流渠道 */
  optionalLogisticsChannel = "";

  /** 自选物流渠道编码 */
  optionalLogisticsChannelCode = "";

  /** 自选物流商 */
  optionalLogisticsCompany = "";

  /** 自选物流商编码 */
  optionalLogisticsCompanyCode = "";

  /** 自选发货仓库 */
  optionalLogisticsDeliveryWarehouse = "";

  /** 自选发货仓库编码 */
  optionalLogisticsDeliveryWarehouseCode = "";

  /** 自选FBA店铺编号 */
  optionalShopKey = "";

  /** 自选FBA店铺名 */
  optionalShopName = "";

  /** 平台邮寄方式 */
  platformPost = "";

  /** 包裹商品数量 */
  qty = undefined;

  /** 推荐原因详情 */
  returnExplain = "";

  /** 退件原因 */
  returnReason = "";

  /** 退件时间 */
  returnTime = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 包裹明细信息 */
  systemOrderPackageItemDtoList = [];

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 更新时间 */
  updateTime = "";

  /** wms出库计划单号 */
  wmsOpNo = "";
}

class SystemOrderPackageItemDto {
  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 财务税额总额（目前只有toB） */
  financeTotalTaxAmount = undefined;

  /** 财务含税总额（目前只有toB） */
  financeTotalTaxPrice = undefined;

  /** 财务未税总额（目前只有toB） */
  financeTotalUnTaxAmount = undefined;

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 平台sku */
  msku = "";

  /** 包裹号 */
  opNo = "";

  /** 包裹item编号 */
  pioItemNo = "";

  /** 包裹单item类型：1正常 2换货 */
  pioType = undefined;

  /** 数量 */
  quantity = undefined;

  /** 发货数量 */
  quantityShipment = undefined;

  /** 已退数量 */
  refundQty = undefined;

  /** sku */
  sku = "";

  /** 系统订单商品号 */
  soItemNo = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 平台订单商品号 */
  spItemNo = "";

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 更新时间 */
  updateTime = "";
}

class SystemOrderPackageItemResponseDto {
  /** 锁定数量（齐货数量） */
  lockQty = undefined;

  /** 锁定仓库 */
  lockWarehouse = "";

  /** 锁定仓库编码 */
  lockWarehouseCode = "";

  /** 平台sku */
  msku = "";

  /** 包裹单号 */
  opNo = "";

  /** 包裹item编号 */
  pioItemNo = "";

  /** 包裹单item类型 */
  pioType = undefined;

  /** 单价 */
  price = undefined;

  /** 数量 */
  qty = undefined;

  /** 是否翻新SKU 0不是 1是 */
  renovateSku = undefined;

  /** 发运状态 1:待发运 2:已发运 3:部分发运 */
  shipmentStatus = undefined;

  /** sku */
  sku = "";

  /** 商品名称 */
  skuName = "";

  /** 系统订单商品号 */
  soItemNo = "";

  /** 平台订单商品号 */
  spItemNo = "";

  /** 总价 */
  totalPrice = undefined;

  /** 交易号 */
  transactionId = "";
}

class SystemOrderPackageItemResponseRpcDto {
  /** msku */
  msku = "";

  /** 包裹号 */
  opNo = "";

  /** 包裹item编号 */
  pioItemNo = "";

  /** 包裹单item类型：1正常 2换货 */
  pioType = undefined;

  /** 数量 */
  quantity = undefined;

  /** 发货数量 */
  quantityShipment = undefined;

  /** 未发货数量 */
  quantityUnshipped = undefined;

  /** 已退数量 */
  refundQty = undefined;

  /** sku */
  sku = "";

  /** 系统订单商品号 */
  soItemNo = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 平台订单商品号 */
  spItemNo = "";
}

class SystemOrderPackageResponseDto {
  /** 是否可以直接提交订单 */
  checkSubmit = false;

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 发货时间 */
  logisticsDeliveryTime = "";

  /** 发货仓库 */
  logisticsDeliveryWarehouse = "";

  /** 发货仓库编码 */
  logisticsDeliveryWarehouseCode = "";

  /** 推送到PayPal状态 1未推送 2 推送成功 3 推送失败 */
  logisticsPaypalTracking = undefined;

  /** 物流单号 */
  logisticsTrackingNo = "";

  /** 包裹单 */
  opNo = "";

  /** 包裹状态 */
  opStatus = undefined;

  /** 包裹总价 */
  opTotalPrice = undefined;

  /** 包裹重量(g) */
  opWeight = "";

  /** sku详情 */
  orderPackageItemDetailVos = [];

  /** 是否翻新SKU 0不是 1是 */
  renovateSku = undefined;

  /** 退件原因详情 */
  returnExplain = "";

  /** 退件原因 */
  returnReason = "";

  /** 退件时间 */
  returnTime = "";

  /** 系统订单号 */
  soOrderNo = "";
}

class SystemOrderPackageResponseRpcDto {
  /** 创建时间 */
  createTime = "";

  /** 派送方式 0:非买家自提，1买家自提 */
  deliveryMethod = undefined;

  /** 包裹明细 */
  itemResponseRpcDtoList = [];

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 发货时间 */
  logisticsDeliveryTime = "";

  /** 发货仓库 */
  logisticsDeliveryWarehouse = "";

  /** 发货仓库编码 */
  logisticsDeliveryWarehouseCode = "";

  /** 推送到paypal状态 1未推送 2 推送成功 3 推送失败 */
  logisticsPaypalTracking = undefined;

  /** 物流运费 */
  logisticsPrice = undefined;

  /** 物流跟踪号 */
  logisticsTrackingNo = "";

  /** 推送到平台状态 1未推送 2 推送成功 3 推送失败 */
  logisticsUpload = undefined;

  /** 推送到平台结果 */
  logisticsUploadMsg = "";

  /** 异常原因 */
  opErrorReason = "";

  /** 包裹单号 */
  opNo = "";

  /** 推送状态 1未推送 2推送成功 3推送失败 */
  opRpcStatus = undefined;

  /** 推送时间 */
  opRpcTime = "";

  /** 包裹状态 1:待审核 2:缺货 3:物流匹配失败 4:发货问题 5:已拦截 6:已发运 7:已取消 8:待发运 9:异常包裹 10:派送失败 11:部分发运 */
  opStatus = undefined;

  /** 包裹重量 */
  opWeight = undefined;

  /** 是否申请多渠道订单 1:是 0:否 */
  optionalIsMcf = undefined;

  /** 自选物流渠道 */
  optionalLogisticsChannel = "";

  /** 自选物流渠道编码 */
  optionalLogisticsChannelCode = "";

  /** 自选物流商 */
  optionalLogisticsCompany = "";

  /** 自选物流商编码 */
  optionalLogisticsCompanyCode = "";

  /** 自选发货仓库 */
  optionalLogisticsDeliveryWarehouse = "";

  /** 自选发货仓库编码 */
  optionalLogisticsDeliveryWarehouseCode = "";

  /** 自选店铺编号 */
  optionalShopKey = "";

  /** 自选店铺名称 */
  optionalShopName = "";

  /** 平台邮寄方式 */
  platformPost = "";

  /** 包裹商品数量 */
  qty = undefined;

  /** 退件原因详情 */
  returnExplain = "";

  /** 退件原因 */
  returnReason = "";

  /** 退件时间 */
  returnTime = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** wms出库计划单号 */
  wmsOpNo = "";
}

class SystemOrderRelevanceRequestParamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 物流公司 */
  platformPost = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 物流跟踪号 */
  trackingNo = "";

  /** 是否上传物流跟踪号 0：预传跟踪号，1：已传输跟踪号 */
  trackingNoStatus = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SystemOrderRemarkDto {
  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 系统订单备注 */
  remark = "";

  /** 系统订单编号 */
  soOrderNo = "";

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 更新时间 */
  updateTime = "";
}

class SystemOrderRemarkRequestDto {
  /** 创建人 */
  createBy = "";

  /** 系统订单备注 */
  remark = "";

  /** 系统订单编号 */
  soOrderNo = "";
}

class SystemOrderRemarkRpcDto {
  /** 创建人 */
  createBy = "";

  /** 系统订单备注 */
  remark = "";

  /** 系统订单编号 */
  soOrderNo = "";
}

class SystemOrderRequestParamsDto {
  /** 买家ID/编号 */
  buyerCode = "";

  /** 买家Email */
  buyerEmail = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 客户信息id,主要用于线下销售订单 */
  customerName = "";

  /** 派送方式 */
  deliveryMethod = undefined;

  /** id */
  id = undefined;

  /** 物流跟踪号 */
  logisticsTrackingNo = "";

  /** 包裹单号 */
  opNo = "";

  /** 发运方式 1:平台配送 2:卖家自配送 */
  orderShipmentMethod = undefined;

  /** 订单来源类型 1:平台订单,2:线下销售订单 */
  orderType = undefined;

  /** 退件原因 */
  returnReason = "";

  /** 退件时间 */
  returnTime = "";

  /** 退件开始时间 */
  returnTimeGe = "";

  /** 退件结束时间 */
  returnTimeLe = "";

  /** 收件人所在国家编码 */
  shippingCountryCode = "";

  /** 收件人邮箱 */
  shippingEmail = "";

  /** 收件人 */
  shippingName = "";

  /** 收件人联系方式 */
  shippingPhone = "";

  /** sku */
  sku = "";

  /** 系统订单售后状态 1正常 2退款 3部分退款 4退货 5部分退货 */
  soAfterSaleStatus = "";

  /** 系统订单生成方式 1:平台传输生成 2:系统内创建 */
  soBuildAction = undefined;

  /** 系统订单异常原因 */
  soErrorCause = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 系统订单号多选，英文逗号分隔 */
  soOrderNos = "";

  /** 系统订单付款状态 1已付款 2部分退款 3已退款 */
  soPayStatus = "";

  /** 系统订单备注 */
  soRemark = "";

  /** 系统订单状态:1待审核  2待发货 3缺货 4物流问题 5发货问题 6部分发货 7已完成 8已取消 9风险订单 10已拦截 */
  soStatus = undefined;

  /** 贸易主体编码 */
  soTradeCompanyCode = "";

  /** 贸易主体名称 */
  soTradeCompanyName = "";

  /** 系统订单类型 1正常 2补发 3重发 4测评 5改发 */
  soType = undefined;

  /** 平台订单币种 */
  spCurrency = "";

  /** 平台订单店铺 */
  spMarketCode = "";

  /** 平台订单店铺名称 */
  spMarketName = "";

  /** 平台订单号ID */
  spOrderId = "";

  /** 平台订单号 */
  spOrderNo = "";

  /** 平台订单下单时间 */
  spOrderTime = "";

  /** 平台订单下单开始时间 */
  spOrderTimeGe = "";

  /** 平台订单下单结束时间 */
  spOrderTimeLe = "";

  /** 平台订单来源平台 */
  spPlatform = "";

  /** 平台站点 */
  spSite = undefined;

  /** 平台订单状态 */
  spStatus = "";

  /** 是否上传物流跟踪号 0：预传跟踪号，1：已传输跟踪号 */
  trackingNoStatus = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SystemOrderRequestRpcDto {
  /** 买家id/code */
  buyerCode = "";

  /** 买家邮箱 */
  buyerEmail = "";

  /** 买家电话 */
  buyerPhone = "";

  /** 页数 */
  current = undefined;

  /** orderId */
  orderId = "";

  /** 收件人邮箱 */
  shippingEmail = "";

  /** 收件人 */
  shippingName = "";

  /** 条数 */
  size = undefined;

  /** 系统订单号 */
  soOrderNo = "";

  /** 平台单号 */
  spOrderNo = "";

  /** 平台订单下单开始时间 */
  spOrderTimeGe = "";

  /** 平台订单下单结束时间 */
  spOrderTimeLe = "";
}

class SystemOrderResponseDto {
  /** 买家ID/编号 */
  buyerCode = "";

  /** 买家邮箱 */
  buyerEmail = "";

  /** 买家留言 */
  buyerMessage = "";

  /** 是否可以直接提交订单 */
  checkSubmit = false;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 客户信息id,主要用于线下销售订单 */
  customerName = "";

  /** 派送方式 */
  deliveryMethod = undefined;

  /** id */
  id = undefined;

  /** 物流运费 */
  logisticsShipping = undefined;

  /** 发运方式 1.平台配送 2.卖家配送 */
  orderShipmentMethod = undefined;

  /** 订单来源类型 1.线下销售订单，2.线下销售订单 3.外包系统订单 4.wfs订单 5.京配订单 6.京东自营订单 */
  orderType = undefined;

  /** 收件人地址1 */
  shippingAddress1 = "";

  /** 收件人地址2 */
  shippingAddress2 = "";

  /** 收件人城市 */
  shippingCity = "";

  /** 收件人所在国家 */
  shippingCountry = "";

  /** 收件人所在国家编码 */
  shippingCountryCode = "";

  /** 收件人邮箱 */
  shippingEmail = "";

  /** 收件人名字 */
  shippingName = "";

  /** 收件人电话 */
  shippingPhone = "";

  /** 收件人邮编 */
  shippingPostCode = "";

  /** 收件人州或省 */
  shippingStateOrProvince = "";

  /** 收件人州或省编码 */
  shippingStateOrProvinceCode = "";

  /** 系统订单售后状态 1正常 2退款 3部分退款 4退货 5部分退货 */
  soAfterSaleStatus = undefined;

  /** 系统订单生成方式 1:平台传输生成 2:系统内创建 */
  soBuildAction = undefined;

  /** 系统订单取消原因 */
  soCancelReason = "";

  /** 系统订单异常原因 */
  soErrorCause = "";

  /** 系统订单拦截原因 */
  soInterceptReson = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 系统订单付款状态 1已付款 2部分退款 3已退款 */
  soPayStatus = undefined;

  /** 系统订单退款金额 */
  soRefundAmount = undefined;

  /** 系统订单备注 */
  soRemark = "";

  /** 子订单类型 1维修,2换货,3其他  */
  soSonStatus = undefined;

  /** 系统订单状态:1待审核  2待发货 3缺货 4物流问题 5发货问题 6部分发货 7已完成 8已取消 9风险订单 10已拦截 */
  soStatus = undefined;

  /** 贸易主体code */
  soTradeCompanyCode = "";

  /** 贸易主体名称 */
  soTradeCompanyName = "";

  /** 系统订单类型 1正常 2补发 3重发 4测评 5改发 */
  soType = undefined;

  /** 平台订单佣金 */
  spCommission = undefined;

  /** 平台订单币种 */
  spCurrency = "";

  /** 平台订单优惠额 */
  spDiscount = undefined;

  /** 平台订单店铺 */
  spMarketCode = "";

  /** 平台订单店铺名称 */
  spMarketName = "";

  /** 平台id */
  spOrderId = "";

  /** 平台订单号 */
  spOrderNo = "";

  /** 平台订单下单时间 */
  spOrderTime = "";

  /** 平台订单实收款 */
  spPayAmount = undefined;

  /** 平台订单支付时间 */
  spPaymentDate = "";

  /** 平台订单来源平台 */
  spPlatform = "";

  /** 平台订单退款金额 */
  spRefundAmount = undefined;

  /** 平台订单备注 */
  spRemark = "";

  /** 平台订单销售价 */
  spSalesPrice = undefined;

  /** 平台订单运费 */
  spShipping = undefined;

  /** 平台订单状态 */
  spStatus = "";

  /** 平台订单税费 */
  spTaxes = undefined;

  /** 平台订单交易价 */
  spTradingPrice = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SystemOrderResponseRpcDto {
  /** 关联订单 */
  associatedOrder = [];

  /** 买家ID/编号 */
  buyerCode = "";

  /** 买家邮箱 */
  buyerEmail = "";

  /** 创建人 */
  createBy = "";

  /** 仓库首次完成拣货时间 */
  finishPickingTime = "";

  /** 仓库首次实际出货时间 */
  firstActualDeliveryTime = "";

  /** 仓库首次拣货时间 */
  firstPickUpTime = "";

  /** 发运方式 1.平台配送 2.卖家配送 */
  orderShipmentMethod = undefined;

  /** 订单来源类型 1.平台销售订单，2.企业订单  */
  orderType = undefined;

  /** 地址1 */
  shippingAddress1 = "";

  /** 地址2 */
  shippingAddress2 = "";

  /** 城市 */
  shippingCity = "";

  /** 国家 */
  shippingCountry = "";

  /** 国家简称 */
  shippingCountryCode = "";

  /** 邮箱 */
  shippingEmail = "";

  /** 收件人 */
  shippingName = "";

  /** 电话 */
  shippingPhone = "";

  /** 邮编 */
  shippingPostCode = "";

  /** 州 */
  shippingStateOrProvince = "";

  /** 州简称 */
  shippingStateOrProvinceCode = "";

  /** 售后状态 */
  soAfterSaleStatus = undefined;

  /** 系统订单生成方式 1:平台传输生成 2:系统内创建 */
  soBuildAction = undefined;

  /** 订单编号 */
  soOrderNo = "";

  /** 付款状态 */
  soPayStatus = undefined;

  /** 系统订单退款金额 */
  soRefundAmount = undefined;

  /** 平台备注 */
  soRemark = "";

  /** 订单状态 */
  soStatus = undefined;

  /** 订单类型 */
  soType = undefined;

  /** 折扣 */
  spDiscount = undefined;

  /** 店铺编码 */
  spMarketCode = "";

  /** 店铺 */
  spMarketName = "";

  /** 平台订单id */
  spOrderId = "";

  /** 平台单号 */
  spOrderNo = "";

  /** 平台订单下单时间 */
  spOrderTime = "";

  /** 实收金额 */
  spPayAmount = undefined;

  /** 平台 */
  spPlatform = "";

  /** 退款金额 */
  spRefundAmount = undefined;

  /** 系统备注 */
  spRemark = "";

  /** 订单金额 */
  spSalesPrice = undefined;

  /** 平台订单运费 */
  spShipping = undefined;

  /** 支付金额 */
  spTradingPrice = undefined;
}

class SystemOrderSaveParamsDto {
  /** 被关联订单 */
  associatedOrder = "";

  /** 发运方式 */
  optionalShippingMethodDto = new OptionalShippingRequestDto();

  /** 订单来源类型 1:平台订单,2:企业订单 */
  orderType = undefined;

  /** 收件人地址1 */
  shippingAddress1 = "";

  /** 收件人地址2 */
  shippingAddress2 = "";

  /** 收件人城市 */
  shippingCity = "";

  /** 收件人所在国家 */
  shippingCountry = "";

  /** 收件人所在国家编码 */
  shippingCountryCode = "";

  /** 收件人邮箱 */
  shippingEmail = "";

  /** 收件人名字 */
  shippingName = "";

  /** 收件人电话 */
  shippingPhone = "";

  /** 收件人邮编 */
  shippingPostCode = "";

  /** 收件人州或省 */
  shippingStateOrProvince = "";

  /** 收件人州或省编码 */
  shippingStateOrProvinceCode = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 备注 */
  soRemark = "";

  /** 订单类型 1正常 2补发 3重发 4测评 5改发 */
  soType = undefined;

  /** 币种 */
  spCurrency = "";

  /** 折扣 */
  spDiscount = undefined;

  /** 店铺编号 */
  spMarketCode = "";

  /** 店铺名称 */
  spMarketName = "";

  /** 平台单号 */
  spOrderNo = "";

  /** 实收金额 */
  spPayAmount = undefined;

  /** 订单来源 */
  spPlatform = "";

  /** 已退金额 */
  spRefundAmount = undefined;

  /** 订单金额 */
  spSalesPrice = undefined;

  /** 支付金额 */
  spTradingPrice = undefined;

  /** 商品列表 */
  systemOrderItemSaveParamsDtos = [];

  /** 交易ID */
  transactionId = "";
}

class SystemOrderShippingAmountDto {
  /** shippingAmount */
  shippingAmount = undefined;

  /** soOrderNo */
  soOrderNo = "";

  /** spOrderNo */
  spOrderNo = "";
}

class TaskDto {
  /** 节点编码 */
  nodeKey = "";

  /** 节点名称 */
  nodeName = "";

  /** 任务id */
  taskId = "";
}

class UpdatePathRpcDto {
  /** 面单生成失败原因 */
  failReason = "";

  /** 退货售后单号 */
  mrbNo = "";

  /** 下载面单路径 */
  path = "";

  /** 面单生成状态 */
  pathStatus = "FAIL";
}

class UpdateRemarkDto {
  /** 备注 */
  remark = "";

  /** 系统订单号 */
  soOrderNo = "";
}

class UpdateShippingMethodRequestDto {
  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 包裹单号 */
  opNo = "";
}

class WalmartReturnOrderCheckDto {
  /** qty */
  qty = undefined;

  /** sku */
  sku = "";
}

class WarehouseChildAttributeResponseDto {
  /** 属性编号 */
  attributeCode = "";

  /** 属性名称 */
  attributeName = "";

  /** 主键 */
  id = undefined;

  /** 子仓库编号 */
  warehouseCode = "";

  /** 子仓库名称 */
  warehouseName = "";
}

class WarehouseChildResponseDetailDto {
  /** 区域 */
  area = "";

  /** 是否指定库位 0-是 1-否 */
  isPosition = undefined;

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库名称 */
  rootWarehouseName = "";

  /** 仓库状态  0:停用 1:启用 */
  status = undefined;

  /** 禁止批次标识 0:否1:是 */
  stopBatchFlag = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商idName */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 三方仓标识 */
  thirdWarehouseFlag = "";

  /** 三方仓编号 */
  thirdWarehouseNo = "";

  /** 仓库类型 10:自营仓 20:FBA仓 30:三方仓 40:工厂仓 50:WFS仓 60:虚拟仓 */
  type = undefined;

  /** 子库属性 */
  warehouseChildAttributeResponseDtoList = [];

  /** 子仓库编号 */
  warehouseCode = "";

  /** 子仓库名称 */
  warehouseName = "";

  /** 子仓英文名称 */
  warehouseNameEn = "";
}

class WmsResultsDto {
  /** 消息 */
  msg = "";

  /** 包裹号 */
  opNo = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 是否成功 */
  success = false;
}

class WmsResultsRpcDto {
  /** 消息 */
  msg = "";

  /** 包裹号 */
  opNo = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 是否成功 */
  success = false;
}

export const omsFlow = {
  AmazonRefundOrderInfoRpcRequest,
  AmazonRefundOrderInfoRpcResponse,
  ApprovalBeforeRequestDto,
  ApprovalRequestDto,
  AsMaterialRejectBillCancelDto,
  AsMaterialRejectBillInvalidRequestDto,
  AsMaterialRejectBillItemRequestDto,
  AsMaterialRejectBillItemResponseDto,
  AsMaterialRejectBillItemRpcVo,
  AsMaterialRejectBillItemVo,
  AsMaterialRejectBillModel,
  AsMaterialRejectBillMultipleRequestDto,
  AsMaterialRejectBillMultipleRpcDto,
  AsMaterialRejectBillRequestDto,
  AsMaterialRejectBillRequestParamsDto,
  AsMaterialRejectPageRpcDto,
  AsRefundOrderItemRequestDto,
  AsRefundOrderItemResponseDto,
  AsRefundOrderItemResponseRpc,
  AsRefundOrderItemRpcDto,
  AsRefundOrderRequestDto,
  AsRefundOrderRequestParamsDto,
  AssigneeDto,
  AssociateSkuParamDto,
  AssociateSkuParamRpcDto,
  BatchUnLockReqDto,
  BatchUnLockRespDto,
  BusinessOrderPackageDetachableVo,
  BusinessOrderPackageDetailVo,
  BusinessOrderPackageItemDetailVo,
  CheckFulfillmentOrderDto,
  CheckFulfillmentOrderRpcDto,
  CrateMskuMapAndFnskuRpcDto,
  CreatePackageToItemIdRequestDto,
  CurrentTaskDto,
  DeliveryInformationRequestDto,
  DeliveryItemRequestDto,
  DetachablePackageItemParamDto,
  DetachablePackageItemParamRpcDto,
  DetachablePackageParamDto,
  DetachablePackageRpcDto,
  Element,
  ExchangeGoodsItemDto,
  FnskuMapItemRequestDto,
  FnskuMapItemResponseDto,
  FnskuMapsItemRequestDto,
  FnskuToMapRpcDto,
  IPage,
  InPlanDetailCreateRequestParamsDto,
  LockStockItemRequestDto,
  LockStockItemResponseDto,
  LockStockRequestDto,
  LockStockResponseDto,
  LockStockRootRequestDto,
  LockStockRootResponseDto,
  LogisticsReverseLabelRequestDto,
  ManualTrackingPayPalDto,
  MskuMapItemRequestRpcDto,
  MskuMapItemResponseDto,
  MskuMapItemResponseDto0,
  MskuMapParamsResponseDto,
  MskuMapParamsRpcDto,
  MskuMapSaveRequestDto,
  MskuMapSaveRequestRpcDto,
  MskuMapsItemResponseDto,
  MskuMapsParamsResponseDto,
  MskuMapsRequestDto,
  MskuMapsRequestRpcDto,
  MskuRequestRpcDto,
  OmsFlowPackageChangeDetailRequestDto,
  OmsFlowPackageChangeDetailSkuRequestDto,
  OmsFlowPackageChangeRequestDto,
  OmsPackageInfoDetailDto,
  OmsPackageInfoDto,
  OptionalShippingMethodDto,
  OptionalShippingRequestDto,
  OrderAsRefundDto,
  OrderAvgPriceResponseDto,
  OrderDetailRequestDto,
  OrderDetailResponseDto,
  OrderInfoRequestDto,
  OrderInfoResponseDto,
  OrderInfoSkuResponseDto,
  OrderItem,
  OrderItemDetailResponseDto,
  OrderItemDetailResponseDtoForFreshDeskData,
  OrderLastMskuPriceResponseDto,
  OrderPackageDetachableRpcDto,
  OrderPackageDetachableVo,
  OrderPackageDetailResponseDto,
  OrderPackageDetailVo,
  OrderPackageItemDetailResponseDto,
  OrderPackageItemDetailVo,
  OrderParamRequestDto,
  OrderRefundDto,
  OrderRefundItemDto,
  OrderSkuItem,
  OrderSkuItemRequestDto,
  OrderSkuResponseDto,
  OrderSyncSystemOrderRemarkDto,
  OrderUpdatePriceDto,
  OrderUpdatePriceItemDto,
  OutPlanStatusResultDto,
  PackageExchangeGoodsDto,
  PackageExchangeGoodsItemRpcDto,
  PackageExchangeGoodsRpcDto,
  PackageItemParamDto,
  PackageItemParamRpcDto,
  PackageItemResponseRpcDto,
  Page,
  PaymentPeriodAndDepositRatioResponseDto,
  PlatformOrderDto,
  PlatformOrderItemDto,
  PlatformOrderRelationDto,
  ProductLabelResponseDto,
  RefundOrderDvo,
  RefundOrderOperationDto,
  RejectBillCallBackRpcDto,
  RejectBillDvo,
  RejectBillItemCallBackRpcDto,
  RejectBillOperationDto,
  RejectBillPageDto,
  Response,
  ResponseDto,
  ResubmitPackageRequestDto,
  ResubmitPackageRpcDto,
  ReturnReasonEnumResponseDto,
  SellerSkuToMapRpcDto,
  SkuPriceRequestDto,
  SkuShippedResultDto,
  SystemOrderContractRequestDto,
  SystemOrderContractResponseDto,
  SystemOrderContractResponseRpcDto,
  SystemOrderContractSkuItemResponseDto,
  SystemOrderCorrelationDto,
  SystemOrderCorrelationRpcDto,
  SystemOrderDetailResponseDto,
  SystemOrderDto,
  SystemOrderHeaderDto,
  SystemOrderItemDetailResponseDto,
  SystemOrderItemDto,
  SystemOrderItemParamsDto,
  SystemOrderItemResponseDto,
  SystemOrderItemSaveParamsDto,
  SystemOrderItemSaveRpcDto,
  SystemOrderPackageDeliveryInformationDto,
  SystemOrderPackageDeliveryRequestDto,
  SystemOrderPackageDeliveryResponseDto,
  SystemOrderPackageDeliveryRpcDto,
  SystemOrderPackageDeliveryRpcResponseDto,
  SystemOrderPackageDto,
  SystemOrderPackageItemDto,
  SystemOrderPackageItemResponseDto,
  SystemOrderPackageItemResponseRpcDto,
  SystemOrderPackageResponseDto,
  SystemOrderPackageResponseRpcDto,
  SystemOrderRelevanceRequestParamsDto,
  SystemOrderRemarkDto,
  SystemOrderRemarkRequestDto,
  SystemOrderRemarkRpcDto,
  SystemOrderRequestParamsDto,
  SystemOrderRequestRpcDto,
  SystemOrderResponseDto,
  SystemOrderResponseRpcDto,
  SystemOrderSaveParamsDto,
  SystemOrderShippingAmountDto,
  TaskDto,
  UpdatePathRpcDto,
  UpdateRemarkDto,
  UpdateShippingMethodRequestDto,
  WalmartReturnOrderCheckDto,
  WarehouseChildAttributeResponseDto,
  WarehouseChildResponseDetailDto,
  WmsResultsDto,
  WmsResultsRpcDto,
};
